// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/events/v1/events.proto" (package "agency.events.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../google/protobuf/any";
import { Usage } from "../../infer/v1/infer";
import { FinishReason } from "../../infer/v1/infer";
import { InferRequest } from "../../infer/v1/infer";
import { ContextBundle } from "../../context/v1/context";
import { SessionState } from "../../session/v1/session";
import { ToolCall } from "../../tool/v1/tool";
import { Plan } from "../../session/v1/session";
import { Goal } from "../../session/v1/session";
import { ErrorClass } from "../../tool/v1/tool";
import { ToolPartialResult } from "../../tool/v1/tool";
import { Struct } from "../../../google/protobuf/struct";
import { ToolResult } from "../../tool/v1/tool";
import { Message } from "../../session/v1/session";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * TurnStart signals the beginning of a conversation turn.
 *
 * @generated from protobuf message agency.events.v1.TurnStart
 */
export interface TurnStart {
    /**
     * turn_id uniquely identifies this turn.
     *
     * @generated from protobuf field: string turn_id = 1
     */
    turnId: string;
    /**
     * session_id is the session this turn belongs to.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * turn_number is the sequential turn count.
     *
     * @generated from protobuf field: int32 turn_number = 3
     */
    turnNumber: number;
    /**
     * started_at is when the turn began.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 4
     */
    startedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the event that caused this turn (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
    /**
     * user_content is the user message that initiated this turn.
     *
     * @generated from protobuf field: string user_content = 6
     */
    userContent: string;
}
/**
 * TurnEnd signals the completion of a conversation turn.
 *
 * @generated from protobuf message agency.events.v1.TurnEnd
 */
export interface TurnEnd {
    /**
     * turn_id uniquely identifies this turn.
     *
     * @generated from protobuf field: string turn_id = 1
     */
    turnId: string;
    /**
     * session_id is the session this turn belongs to.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * assistant_message is the final assistant response.
     *
     * @generated from protobuf field: agency.session.v1.Message assistant_message = 3
     */
    assistantMessage?: Message;
    /**
     * parent_event_id is the ID of the TurnStart event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 7
     */
    parentEventId: string;
    /**
     * tool_results are the tool execution results from this turn.
     *
     * @generated from protobuf field: repeated agency.tool.v1.ToolResult tool_results = 4
     */
    toolResults: ToolResult[];
    /**
     * completed_at is when the turn completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 5
     */
    completedAt?: Timestamp;
    /**
     * tokens_consumed is the token usage for this turn.
     *
     * @generated from protobuf field: int64 tokens_consumed = 6
     */
    tokensConsumed: bigint;
}
/**
 * MessageStart signals the beginning of a message.
 *
 * @generated from protobuf message agency.events.v1.MessageStart
 */
export interface MessageStart {
    /**
     * session_id is the session this message belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this message belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * message is the starting message (may be partial for streaming).
     *
     * @generated from protobuf field: agency.session.v1.Message message = 3
     */
    message?: Message;
    /**
     * started_at is when the message began.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 4
     */
    startedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the event that triggered this message (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
}
/**
 * MessageUpdate provides incremental message updates during streaming.
 *
 * @generated from protobuf message agency.events.v1.MessageUpdate
 */
export interface MessageUpdate {
    /**
     * session_id is the session this message belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this message belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * delta is the incremental update.
     *
     * @generated from protobuf field: agency.events.v1.AssistantMessageDelta delta = 3
     */
    delta?: AssistantMessageDelta;
    /**
     * timestamp is when this update was generated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 4
     */
    timestamp?: Timestamp;
    /**
     * parent_event_id is the ID of the MessageStart event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
}
/**
 * AssistantMessageDelta represents an incremental message update.
 *
 * @generated from protobuf message agency.events.v1.AssistantMessageDelta
 */
export interface AssistantMessageDelta {
    /**
     * Delta content (one of these will be set).
     *
     * @generated from protobuf oneof: delta
     */
    delta: {
        oneofKind: "textDelta";
        /**
         * text_delta is incremental text content.
         *
         * @generated from protobuf field: string text_delta = 1
         */
        textDelta: string;
    } | {
        oneofKind: "thinkingDelta";
        /**
         * thinking_delta is incremental thinking content.
         *
         * @generated from protobuf field: string thinking_delta = 2
         */
        thinkingDelta: string;
    } | {
        oneofKind: "toolcallDelta";
        /**
         * toolcall_delta is incremental tool call JSON.
         *
         * @generated from protobuf field: string toolcall_delta = 3
         */
        toolcallDelta: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * content_index is the index of the content block being updated.
     *
     * @generated from protobuf field: int32 content_index = 4
     */
    contentIndex: number;
}
/**
 * MessageEnd signals message completion.
 *
 * @generated from protobuf message agency.events.v1.MessageEnd
 */
export interface MessageEnd {
    /**
     * session_id is the session this message belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this message belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * message is the complete final message.
     *
     * @generated from protobuf field: agency.session.v1.Message message = 3
     */
    message?: Message;
    /**
     * completed_at is when the message completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 4
     */
    completedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the MessageStart event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
}
/**
 * ToolExecutionStart signals the beginning of tool execution.
 *
 * @generated from protobuf message agency.events.v1.ToolExecutionStart
 */
export interface ToolExecutionStart {
    /**
     * session_id is the session this execution belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this execution belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * tool_call_id is the unique tool call identifier.
     *
     * @generated from protobuf field: string tool_call_id = 3
     */
    toolCallId: string;
    /**
     * tool_name is the tool being executed.
     *
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * args are the tool arguments.
     *
     * @generated from protobuf field: google.protobuf.Struct args = 5
     */
    args?: Struct;
    /**
     * started_at is when execution began.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 6
     */
    startedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the event that triggered this execution (optional).
     *
     * @generated from protobuf field: string parent_event_id = 7
     */
    parentEventId: string;
}
/**
 * ToolExecutionUpdate provides streaming tool execution updates.
 *
 * @generated from protobuf message agency.events.v1.ToolExecutionUpdate
 */
export interface ToolExecutionUpdate {
    /**
     * session_id is the session this execution belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this execution belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * tool_call_id is the unique tool call identifier.
     *
     * @generated from protobuf field: string tool_call_id = 3
     */
    toolCallId: string;
    /**
     * tool_name is the tool being executed.
     *
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * partial is the incremental result.
     *
     * @generated from protobuf field: agency.tool.v1.ToolPartialResult partial = 5
     */
    partial?: ToolPartialResult;
    /**
     * timestamp is when this update was generated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6
     */
    timestamp?: Timestamp;
    /**
     * parent_event_id is the ID of the ToolExecutionStart event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 7
     */
    parentEventId: string;
}
/**
 * ToolExecutionEnd signals tool execution completion.
 *
 * @generated from protobuf message agency.events.v1.ToolExecutionEnd
 */
export interface ToolExecutionEnd {
    /**
     * session_id is the session this execution belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this execution belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * tool_call_id is the unique tool call identifier.
     *
     * @generated from protobuf field: string tool_call_id = 3
     */
    toolCallId: string;
    /**
     * tool_name is the tool being executed.
     *
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * result is the final tool result.
     *
     * @generated from protobuf field: agency.tool.v1.ToolResult result = 5
     */
    result?: ToolResult;
    /**
     * completed_at is when execution completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 6
     */
    completedAt?: Timestamp;
    /**
     * is_error indicates if execution failed.
     *
     * @generated from protobuf field: bool is_error = 7
     */
    isError: boolean;
    /**
     * error_class classifies the error for retry policy.
     *
     * @generated from protobuf field: agency.tool.v1.ErrorClass error_class = 8
     */
    errorClass: ErrorClass;
    /**
     * error_message describes the failure.
     *
     * @generated from protobuf field: string error_message = 9
     */
    errorMessage: string;
    /**
     * parent_event_id is the ID of the ToolExecutionStart event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 10
     */
    parentEventId: string;
}
/**
 * PlanEvent publishes the extracted goal and plan.
 *
 * @generated from protobuf message agency.events.v1.PlanEvent
 */
export interface PlanEvent {
    /**
     * session_id is the session this plan belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * goal is the extracted high-level objective.
     *
     * @generated from protobuf field: agency.session.v1.Goal goal = 2
     */
    goal?: Goal;
    /**
     * plan is the extracted execution plan.
     *
     * @generated from protobuf field: agency.session.v1.Plan plan = 3
     */
    plan?: Plan;
    /**
     * planned_at is when the plan was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp planned_at = 4
     */
    plannedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the event that triggered planning (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
}
/**
 * StepEvent records a single execution step (tool call + result).
 *
 * @generated from protobuf message agency.events.v1.StepEvent
 */
export interface StepEvent {
    /**
     * session_id is the session this step belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * step_index is the sequential step number.
     *
     * @generated from protobuf field: int32 step_index = 2
     */
    stepIndex: number;
    /**
     * tool_call is the tool invocation.
     *
     * @generated from protobuf field: agency.tool.v1.ToolCall tool_call = 3
     */
    toolCall?: ToolCall;
    /**
     * tool_result is the execution result.
     *
     * @generated from protobuf field: agency.tool.v1.ToolResult tool_result = 4
     */
    toolResult?: ToolResult;
    /**
     * completed_at is when the step completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 5
     */
    completedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the event that triggered this step (optional).
     *
     * @generated from protobuf field: string parent_event_id = 6
     */
    parentEventId: string;
}
/**
 * SnapshotEvent checkpoints session state.
 *
 * @generated from protobuf message agency.events.v1.SnapshotEvent
 */
export interface SnapshotEvent {
    /**
     * session_id is the session being snapshotted.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * snapshot_seq is the stream sequence at snapshot time.
     *
     * @generated from protobuf field: uint64 snapshot_seq = 2
     */
    snapshotSeq: bigint;
    /**
     * state is the complete session state.
     * For large snapshots (≥64KB), this may be a reference to Object Store.
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "inlineState";
        /**
         * inline_state is the state embedded in the event.
         *
         * @generated from protobuf field: agency.session.v1.SessionState inline_state = 3
         */
        inlineState: SessionState;
    } | {
        oneofKind: "objectStoreRef";
        /**
         * object_store_ref is a reference to the state in Object Store.
         *
         * @generated from protobuf field: string object_store_ref = 4
         */
        objectStoreRef: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * snapshot_at is when the snapshot was taken.
     *
     * @generated from protobuf field: google.protobuf.Timestamp snapshot_at = 5
     */
    snapshotAt?: Timestamp;
    /**
     * trigger is what triggered the snapshot.
     *
     * @generated from protobuf field: agency.events.v1.SnapshotTrigger trigger = 6
     */
    trigger: SnapshotTrigger;
    /**
     * parent_event_id is the ID of the event that triggered this snapshot (optional).
     *
     * @generated from protobuf field: string parent_event_id = 7
     */
    parentEventId: string;
}
/**
 * AgentDoneEvent signals successful session completion.
 *
 * @generated from protobuf message agency.events.v1.AgentDoneEvent
 */
export interface AgentDoneEvent {
    /**
     * session_id is the completed session.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * final_state is the final session state.
     *
     * @generated from protobuf field: agency.session.v1.SessionState final_state = 2
     */
    finalState?: SessionState;
    /**
     * final_message is the last assistant message.
     *
     * @generated from protobuf field: agency.session.v1.Message final_message = 3
     */
    finalMessage?: Message;
    /**
     * completed_at is when the session completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 4
     */
    completedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the final event that completed the session (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
    /**
     * total_tokens_consumed is the total token usage.
     *
     * @generated from protobuf field: int64 total_tokens_consumed = 6
     */
    totalTokensConsumed: bigint;
    /**
     * total_tool_calls is the total tool call count.
     *
     * @generated from protobuf field: int32 total_tool_calls = 7
     */
    totalToolCalls: number;
    /**
     * duration_seconds is the session duration.
     *
     * @generated from protobuf field: int64 duration_seconds = 8
     */
    durationSeconds: bigint;
}
/**
 * CancelledEvent signals session cancellation.
 *
 * @generated from protobuf message agency.events.v1.CancelledEvent
 */
export interface CancelledEvent {
    /**
     * session_id is the cancelled session.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * reason explains why the session was cancelled.
     *
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
    /**
     * cancelled_by is the entity that triggered cancellation.
     *
     * @generated from protobuf field: string cancelled_by = 3
     */
    cancelledBy: string;
    /**
     * cancelled_at is when cancellation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp cancelled_at = 4
     */
    cancelledAt?: Timestamp;
    /**
     * partial_state is the state at cancellation time.
     *
     * @generated from protobuf field: agency.session.v1.SessionState partial_state = 5
     */
    partialState?: SessionState;
    /**
     * parent_event_id is the ID of the event that triggered cancellation (optional).
     *
     * @generated from protobuf field: string parent_event_id = 6
     */
    parentEventId: string;
}
/**
 * InterruptEvent signals soft session steering (non-terminal).
 *
 * @generated from protobuf message agency.events.v1.InterruptEvent
 */
export interface InterruptEvent {
    /**
     * session_id is the interrupted session.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * steering_messages are user messages to inject for redirection.
     *
     * @generated from protobuf field: repeated agency.session.v1.Message steering_messages = 2
     */
    steeringMessages: Message[];
    /**
     * interrupted_at is when the interrupt occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp interrupted_at = 3
     */
    interruptedAt?: Timestamp;
    /**
     * reason explains the interrupt.
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
    /**
     * parent_event_id is the ID of the event that triggered the interrupt (optional).
     *
     * @generated from protobuf field: string parent_event_id = 5
     */
    parentEventId: string;
}
/**
 * SessionFailedEvent signals session failure.
 *
 * @generated from protobuf message agency.events.v1.SessionFailedEvent
 */
export interface SessionFailedEvent {
    /**
     * session_id is the failed session.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * error_message describes the failure.
     *
     * @generated from protobuf field: string error_message = 2
     */
    errorMessage: string;
    /**
     * error_class classifies the error.
     *
     * @generated from protobuf field: agency.tool.v1.ErrorClass error_class = 3
     */
    errorClass: ErrorClass;
    /**
     * failed_at is when the failure occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp failed_at = 4
     */
    failedAt?: Timestamp;
    /**
     * partial_state is the state at failure time.
     *
     * @generated from protobuf field: agency.session.v1.SessionState partial_state = 5
     */
    partialState?: SessionState;
    /**
     * stack_trace provides debugging information.
     *
     * @generated from protobuf field: string stack_trace = 6
     */
    stackTrace: string;
    /**
     * parent_event_id is the ID of the event that triggered the failure (optional).
     *
     * @generated from protobuf field: string parent_event_id = 7
     */
    parentEventId: string;
}
/**
 * ContextUpdated signals context changes at any pipeline stage.
 *
 * @generated from protobuf message agency.events.v1.ContextUpdated
 */
export interface ContextUpdated {
    /**
     * tenant is the tenant this context belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this context belongs to.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * stage is the pipeline stage that emitted this update.
     *
     * @generated from protobuf field: string stage = 3
     */
    stage: string;
    /**
     * updated_at is when the update occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * revision is the context revision number.
     *
     * @generated from protobuf field: uint64 revision = 5
     */
    revision: bigint;
    /**
     * bundle is the assembled context (optional for backwards compat).
     *
     * @generated from protobuf field: agency.context.v1.ContextBundle bundle = 6
     */
    bundle?: ContextBundle;
}
/**
 * ContextReady signals that context pipeline has completed initial load.
 *
 * @generated from protobuf message agency.events.v1.ContextReady
 */
export interface ContextReady {
    /**
     * tenant is the tenant this context belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this context belongs to.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * ready_at is when context became ready.
     *
     * @generated from protobuf field: google.protobuf.Timestamp ready_at = 3
     */
    readyAt?: Timestamp;
    /**
     * stages_loaded are the pipeline stages that completed.
     *
     * @generated from protobuf field: repeated string stages_loaded = 4
     */
    stagesLoaded: string[];
    /**
     * bundle is the assembled context.
     *
     * @generated from protobuf field: agency.context.v1.ContextBundle bundle = 5
     */
    bundle?: ContextBundle;
}
/**
 * ArtifactUpdated signals changes to workspace artifacts (RAG corpus, etc).
 *
 * @generated from protobuf message agency.events.v1.ArtifactUpdated
 */
export interface ArtifactUpdated {
    /**
     * tenant is the tenant this artifact belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this artifact belongs to (empty for global).
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * artifact_id uniquely identifies the artifact.
     *
     * @generated from protobuf field: string artifact_id = 3
     */
    artifactId: string;
    /**
     * artifact_type describes the artifact (e.g., "corpus", "few_shot_pack").
     *
     * @generated from protobuf field: string artifact_type = 4
     */
    artifactType: string;
    /**
     * updated_at is when the artifact was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * object_store_path is the Object Store path.
     *
     * @generated from protobuf field: string object_store_path = 6
     */
    objectStorePath: string;
    /**
     * size_bytes is the artifact size.
     *
     * @generated from protobuf field: int64 size_bytes = 7
     */
    sizeBytes: bigint;
}
/**
 * ArtifactUploadRequest requests artifact upload to Object Store.
 *
 * @generated from protobuf message agency.events.v1.ArtifactUploadRequest
 */
export interface ArtifactUploadRequest {
    /**
     * tenant is the tenant this artifact belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this artifact belongs to (empty for global).
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * artifact_id uniquely identifies the artifact.
     *
     * @generated from protobuf field: string artifact_id = 3
     */
    artifactId: string;
    /**
     * artifact_type describes the artifact (e.g., "corpus", "few_shot_pack").
     *
     * @generated from protobuf field: string artifact_type = 4
     */
    artifactType: string;
    /**
     * content_type is the MIME type of the artifact.
     *
     * @generated from protobuf field: string content_type = 5
     */
    contentType: string;
    /**
     * metadata contains artifact metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 6
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * ttl_seconds is the time-to-live for the artifact (0 = no expiration).
     *
     * @generated from protobuf field: int64 ttl_seconds = 7
     */
    ttlSeconds: bigint;
}
/**
 * ArtifactDownloadRequest requests artifact download from Object Store.
 *
 * @generated from protobuf message agency.events.v1.ArtifactDownloadRequest
 */
export interface ArtifactDownloadRequest {
    /**
     * tenant is the tenant this artifact belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this artifact belongs to (empty for global).
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * artifact_id uniquely identifies the artifact.
     *
     * @generated from protobuf field: string artifact_id = 3
     */
    artifactId: string;
    /**
     * version is the specific artifact version (empty = latest).
     *
     * @generated from protobuf field: string version = 4
     */
    version: string;
    /**
     * include_metadata requests artifact metadata in response.
     *
     * @generated from protobuf field: bool include_metadata = 5
     */
    includeMetadata: boolean;
}
/**
 * ArtifactMetadata contains detailed artifact metadata.
 *
 * @generated from protobuf message agency.events.v1.ArtifactMetadata
 */
export interface ArtifactMetadata {
    /**
     * artifact_id uniquely identifies the artifact.
     *
     * @generated from protobuf field: string artifact_id = 1
     */
    artifactId: string;
    /**
     * artifact_type describes the artifact type.
     *
     * @generated from protobuf field: string artifact_type = 2
     */
    artifactType: string;
    /**
     * object_store_path is the Object Store path.
     *
     * @generated from protobuf field: string object_store_path = 3
     */
    objectStorePath: string;
    /**
     * size_bytes is the artifact size.
     *
     * @generated from protobuf field: int64 size_bytes = 4
     */
    sizeBytes: bigint;
    /**
     * checksum is the artifact content hash.
     *
     * @generated from protobuf field: string checksum = 5
     */
    checksum: string;
    /**
     * content_type is the MIME type.
     *
     * @generated from protobuf field: string content_type = 6
     */
    contentType: string;
    /**
     * created_at is when the artifact was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * updated_at is when the artifact was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * expires_at is when the artifact expires (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 9
     */
    expiresAt?: Timestamp;
    /**
     * version is the artifact version.
     *
     * @generated from protobuf field: string version = 10
     */
    version: string;
    /**
     * metadata contains custom artifact metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 11
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * tenant is the tenant this artifact belongs to.
     *
     * @generated from protobuf field: string tenant = 12
     */
    tenant: string;
    /**
     * workspace is the workspace this artifact belongs to (empty for global).
     *
     * @generated from protobuf field: string workspace = 13
     */
    workspace: string;
}
/**
 * ArtifactInvalidationEvent signals artifact cache invalidation.
 *
 * @generated from protobuf message agency.events.v1.ArtifactInvalidationEvent
 */
export interface ArtifactInvalidationEvent {
    /**
     * tenant is the tenant this artifact belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this artifact belongs to (empty for global).
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * artifact_id uniquely identifies the artifact.
     *
     * @generated from protobuf field: string artifact_id = 3
     */
    artifactId: string;
    /**
     * invalidation_reason explains why invalidation occurred.
     *
     * @generated from protobuf field: string invalidation_reason = 4
     */
    invalidationReason: string;
    /**
     * invalidated_at is when the invalidation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp invalidated_at = 5
     */
    invalidatedAt?: Timestamp;
    /**
     * affected_versions are the artifact versions invalidated (empty = all).
     *
     * @generated from protobuf field: repeated string affected_versions = 6
     */
    affectedVersions: string[];
}
/**
 * ToolCallFrequencyExceededEvent signals frequency limit violations.
 *
 * @generated from protobuf message agency.events.v1.ToolCallFrequencyExceededEvent
 */
export interface ToolCallFrequencyExceededEvent {
    /**
     * session_id is the session that exceeded the limit.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * tool_name is the tool that exceeded limits.
     *
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * current_frequency is the current call rate.
     *
     * @generated from protobuf field: int32 current_frequency = 5
     */
    currentFrequency: number;
    /**
     * limit is the configured maximum.
     *
     * @generated from protobuf field: int32 limit = 6
     */
    limit: number;
    /**
     * occurred_at is when the violation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 7
     */
    occurredAt?: Timestamp;
    /**
     * error_class indicates error degradation level (ERROR_DEGRADED per QUOTA.md).
     *
     * @generated from protobuf field: string error_class = 8
     */
    errorClass: string;
}
/**
 * RateLimitedEvent signals rate limit violations.
 *
 * @generated from protobuf message agency.events.v1.RateLimitedEvent
 */
export interface RateLimitedEvent {
    /**
     * session_id is the session that was rate limited.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * limit_type describes the rate limit type (e.g., "tokens_per_second", "requests_per_minute").
     *
     * @generated from protobuf field: string limit_type = 4
     */
    limitType: string;
    /**
     * current_rate is the current rate that triggered the limit.
     *
     * @generated from protobuf field: int64 current_rate = 5
     */
    currentRate: bigint;
    /**
     * limit is the configured maximum rate.
     *
     * @generated from protobuf field: int64 limit = 6
     */
    limit: bigint;
    /**
     * retry_after_ms is the milliseconds to wait before retrying.
     *
     * @generated from protobuf field: int64 retry_after_ms = 7
     */
    retryAfterMs: bigint;
    /**
     * occurred_at is when the rate limit was hit.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 8
     */
    occurredAt?: Timestamp;
}
/**
 * HarnessReadyEvent signals harness startup completion.
 *
 * @generated from protobuf message agency.events.v1.HarnessReadyEvent
 */
export interface HarnessReadyEvent {
    /**
     * harness_id identifies this harness instance.
     *
     * @generated from protobuf field: string harness_id = 1
     */
    harnessId: string;
    /**
     * node_id is the node identifier.
     *
     * @generated from protobuf field: string node_id = 2
     */
    nodeId: string;
    /**
     * ready_at is when the harness became ready.
     *
     * @generated from protobuf field: google.protobuf.Timestamp ready_at = 3
     */
    readyAt?: Timestamp;
    /**
     * startup_duration_ms is the startup time in milliseconds.
     *
     * @generated from protobuf field: int64 startup_duration_ms = 4
     */
    startupDurationMs: bigint;
    /**
     * actor_count is the number of actors spawned.
     *
     * @generated from protobuf field: int32 actor_count = 5
     */
    actorCount: number;
}
/**
 * ToolRejectionEvent signals tool call rejection by SecurityGateActor.
 *
 * @generated from protobuf message agency.events.v1.ToolRejectionEvent
 */
export interface ToolRejectionEvent {
    /**
     * session_id is the session where the rejection occurred.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * tool_name is the rejected tool.
     *
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * rejection_reason describes why the tool was rejected.
     *
     * @generated from protobuf field: string rejection_reason = 5
     */
    rejectionReason: string;
    /**
     * rejection_stage indicates where rejection occurred.
     *
     * @generated from protobuf field: string rejection_stage = 6
     */
    rejectionStage: string;
    /**
     * occurred_at is when the rejection occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 7
     */
    occurredAt?: Timestamp;
}
/**
 * SkillExecutionEvent signals skill sandbox execution.
 *
 * @generated from protobuf message agency.events.v1.SkillExecutionEvent
 */
export interface SkillExecutionEvent {
    /**
     * session_id is the session executing the skill.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * skill_id is the executed skill.
     *
     * @generated from protobuf field: string skill_id = 2
     */
    skillId: string;
    /**
     * trust_level is the skill's trust level.
     *
     * @generated from protobuf field: string trust_level = 3
     */
    trustLevel: string;
    /**
     * executed_at is when the skill ran.
     *
     * @generated from protobuf field: google.protobuf.Timestamp executed_at = 4
     */
    executedAt?: Timestamp;
    /**
     * execution_time_ms is the execution duration.
     *
     * @generated from protobuf field: int64 execution_time_ms = 5
     */
    executionTimeMs: bigint;
    /**
     * success indicates if execution succeeded.
     *
     * @generated from protobuf field: bool success = 6
     */
    success: boolean;
    /**
     * error_message describes failures.
     *
     * @generated from protobuf field: string error_message = 7
     */
    errorMessage: string;
}
/**
 * SessionStartFailedEvent signals session spawn failures.
 *
 * @generated from protobuf message agency.events.v1.SessionStartFailedEvent
 */
export interface SessionStartFailedEvent {
    /**
     * session_id is the session that failed to start.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * reason explains the failure.
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
    /**
     * failed_at is when the failure occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp failed_at = 5
     */
    failedAt?: Timestamp;
}
/**
 * DLQAlertEvent alerts operators to DLQ issues.
 *
 * @generated from protobuf message agency.events.v1.DLQAlertEvent
 */
export interface DLQAlertEvent {
    /**
     * stream_name is the stream with DLQ issues.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer with DLQ issues.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * dlq_message_count is the number of messages in DLQ.
     *
     * @generated from protobuf field: uint64 dlq_message_count = 3
     */
    dlqMessageCount: bigint;
    /**
     * threshold_exceeded indicates if alert threshold was exceeded.
     *
     * @generated from protobuf field: bool threshold_exceeded = 4
     */
    thresholdExceeded: boolean;
    /**
     * alert_level is the severity level.
     *
     * @generated from protobuf field: agency.events.v1.AlertLevel alert_level = 5
     */
    alertLevel: AlertLevel;
    /**
     * reason explains the DLQ alert.
     *
     * @generated from protobuf field: string reason = 6
     */
    reason: string;
    /**
     * alerted_at is when the alert was triggered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp alerted_at = 7
     */
    alertedAt?: Timestamp;
    /**
     * sample_message_ids are sample message IDs in DLQ.
     *
     * @generated from protobuf field: repeated string sample_message_ids = 8
     */
    sampleMessageIds: string[];
}
/**
 * RequestFailedEvent notifies clients of request failures.
 *
 * @generated from protobuf message agency.events.v1.RequestFailedEvent
 */
export interface RequestFailedEvent {
    /**
     * request_id uniquely identifies the failed request.
     *
     * @generated from protobuf field: string request_id = 1
     */
    requestId: string;
    /**
     * session_id is the session (if applicable).
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * tenant is the tenant.
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace.
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * failure_reason explains why the request failed.
     *
     * @generated from protobuf field: string failure_reason = 5
     */
    failureReason: string;
    /**
     * failure_code is the error code.
     *
     * @generated from protobuf field: string failure_code = 6
     */
    failureCode: string;
    /**
     * retry_count is the number of retry attempts.
     *
     * @generated from protobuf field: uint32 retry_count = 7
     */
    retryCount: number;
    /**
     * retryable indicates if the request can be retried.
     *
     * @generated from protobuf field: bool retryable = 8
     */
    retryable: boolean;
    /**
     * failed_at is when the failure occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp failed_at = 9
     */
    failedAt?: Timestamp;
    /**
     * dlq_subject is the DLQ subject where the message was sent.
     *
     * @generated from protobuf field: string dlq_subject = 10
     */
    dlqSubject: string;
}
/**
 * ModelFallbackEvent signals fallback to secondary model provider.
 *
 * @generated from protobuf message agency.events.v1.ModelFallbackEvent
 */
export interface ModelFallbackEvent {
    /**
     * session_id is the session using model fallback.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * primary_model_id is the model that failed.
     *
     * @generated from protobuf field: string primary_model_id = 2
     */
    primaryModelId: string;
    /**
     * fallback_model_id is the model used for fallback.
     *
     * @generated from protobuf field: string fallback_model_id = 3
     */
    fallbackModelId: string;
    /**
     * failure_reason explains why fallback occurred.
     *
     * @generated from protobuf field: string failure_reason = 4
     */
    failureReason: string;
    /**
     * fallback_position is the position in the fallback chain (0 = primary, 1 = first fallback, etc).
     *
     * @generated from protobuf field: int32 fallback_position = 5
     */
    fallbackPosition: number;
    /**
     * occurred_at is when the fallback occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 6
     */
    occurredAt?: Timestamp;
    /**
     * tenant is the tenant.
     *
     * @generated from protobuf field: string tenant = 7
     */
    tenant: string;
    /**
     * workspace is the workspace.
     *
     * @generated from protobuf field: string workspace = 8
     */
    workspace: string;
}
/**
 * ModelCircuitBreakerStateChange signals circuit breaker state transitions.
 *
 * @generated from protobuf message agency.events.v1.ModelCircuitBreakerStateChange
 */
export interface ModelCircuitBreakerStateChange {
    /**
     * model_id is the model whose circuit breaker changed.
     *
     * @generated from protobuf field: string model_id = 1
     */
    modelId: string;
    /**
     * provider is the model provider.
     *
     * @generated from protobuf field: string provider = 2
     */
    provider: string;
    /**
     * previous_state is the previous circuit breaker state.
     *
     * @generated from protobuf field: agency.events.v1.CircuitBreakerState previous_state = 3
     */
    previousState: CircuitBreakerState;
    /**
     * new_state is the new circuit breaker state.
     *
     * @generated from protobuf field: agency.events.v1.CircuitBreakerState new_state = 4
     */
    newState: CircuitBreakerState;
    /**
     * failure_count is the number of consecutive failures.
     *
     * @generated from protobuf field: uint32 failure_count = 5
     */
    failureCount: number;
    /**
     * success_count is the number of consecutive successes (for HALF_OPEN).
     *
     * @generated from protobuf field: uint32 success_count = 6
     */
    successCount: number;
    /**
     * changed_at is when the state change occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp changed_at = 7
     */
    changedAt?: Timestamp;
    /**
     * reason explains why the state changed.
     *
     * @generated from protobuf field: string reason = 8
     */
    reason: string;
    /**
     * recovery_time_estimate_seconds is estimated recovery time for OPEN state.
     *
     * @generated from protobuf field: int64 recovery_time_estimate_seconds = 9
     */
    recoveryTimeEstimateSeconds: bigint;
}
/**
 * HarnessShutdownEvent signals harness shutdown.
 *
 * @generated from protobuf message agency.events.v1.HarnessShutdownEvent
 */
export interface HarnessShutdownEvent {
    /**
     * harness_id identifies the shutting down harness.
     *
     * @generated from protobuf field: string harness_id = 1
     */
    harnessId: string;
    /**
     * reason explains why the shutdown occurred.
     *
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
    /**
     * shutdown_type indicates if this is graceful or forced.
     *
     * @generated from protobuf field: agency.events.v1.ShutdownType shutdown_type = 3
     */
    shutdownType: ShutdownType;
    /**
     * active_sessions is the count of active sessions at shutdown.
     *
     * @generated from protobuf field: int32 active_sessions = 4
     */
    activeSessions: number;
    /**
     * shutdown_at is when the shutdown occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp shutdown_at = 5
     */
    shutdownAt?: Timestamp;
    /**
     * drain_timeout_seconds is the graceful drain timeout (if applicable).
     *
     * @generated from protobuf field: int32 drain_timeout_seconds = 6
     */
    drainTimeoutSeconds: number;
}
/**
 * TenantContextEvent injects tenant context during federation.
 *
 * @generated from protobuf message agency.events.v1.TenantContextEvent
 */
export interface TenantContextEvent {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * context_data is the tenant-specific context (prompts, skills, config).
     *
     * @generated from protobuf field: map<string, string> context_data = 2
     */
    contextData: {
        [key: string]: string;
    };
    /**
     * source_harness_id is the originating harness.
     *
     * @generated from protobuf field: string source_harness_id = 3
     */
    sourceHarnessId: string;
    /**
     * injected_at is when the context was injected.
     *
     * @generated from protobuf field: google.protobuf.Timestamp injected_at = 4
     */
    injectedAt?: Timestamp;
    /**
     * delegation_id links to the federation delegation request.
     *
     * @generated from protobuf field: string delegation_id = 5
     */
    delegationId: string;
}
/**
 * ActorSpawnFailedEvent is published when an actor fails to spawn.
 * Used by ErrorActor pattern to make spawn failures observable.
 *
 * @generated from protobuf message agency.events.v1.ActorSpawnFailedEvent
 */
export interface ActorSpawnFailedEvent {
    /**
     * urn is the URN of the actor that failed to spawn.
     *
     * @generated from protobuf field: string urn = 1
     */
    urn: string;
    /**
     * role is the actor role that was requested.
     *
     * @generated from protobuf field: string role = 2
     */
    role: string;
    /**
     * reason describes why the spawn failed.
     *
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
    /**
     * timestamp when the failure occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 4
     */
    timestamp?: Timestamp;
}
/**
 * TokenCount tracks token usage for billing and quota enforcement.
 *
 * @generated from protobuf message agency.events.v1.TokenCount
 */
export interface TokenCount {
    /**
     * input_tokens consumed from the request.
     *
     * @generated from protobuf field: int64 input_tokens = 1
     */
    inputTokens: bigint;
    /**
     * output_tokens generated in the response.
     *
     * @generated from protobuf field: int64 output_tokens = 2
     */
    outputTokens: bigint;
    /**
     * cached_tokens from prompt caching (if supported by provider).
     *
     * @generated from protobuf field: int64 cached_tokens = 3
     */
    cachedTokens: bigint;
    /**
     * total_tokens is input + output tokens.
     *
     * @generated from protobuf field: int64 total_tokens = 4
     */
    totalTokens: bigint;
}
/**
 * LLMCallStart is published to infer-requests.<tenant>.<workspace>.<session>.<turn-id>
 * before LLMClient.Stream() is called. Carries the full InferRequest as payload.
 *
 * @generated from protobuf message agency.events.v1.LLMCallStart
 */
export interface LLMCallStart {
    /**
     * session_id is the session this LLM call belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this LLM call belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * tenant is the tenant that owns this LLM call.
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace this LLM call belongs to.
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * model_id is the model being called.
     *
     * @generated from protobuf field: string model_id = 5
     */
    modelId: string;
    /**
     * request is the full infer request payload.
     *
     * @generated from protobuf field: agency.infer.v1.InferRequest request = 6
     */
    request?: InferRequest;
    /**
     * started_at is when the LLM call was initiated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 7
     */
    startedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the parent event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 8
     */
    parentEventId: string;
}
/**
 * LLMCallEnd is published to the same subject as LLMCallStart after the stream closes.
 * Carries outcome, cost, and timing information.
 *
 * @generated from protobuf message agency.events.v1.LLMCallEnd
 */
export interface LLMCallEnd {
    /**
     * session_id is the session this LLM call belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this LLM call belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * tenant is the tenant that owns this LLM call.
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace this LLM call belongs to.
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * model_id is the model that was called.
     *
     * @generated from protobuf field: string model_id = 5
     */
    modelId: string;
    /**
     * finish_reason is the reason the LLM stream ended.
     *
     * @generated from protobuf field: agency.infer.v1.FinishReason finish_reason = 6
     */
    finishReason: FinishReason;
    /**
     * usage is the token usage for this LLM call.
     *
     * @generated from protobuf field: agency.infer.v1.Usage usage = 7
     */
    usage?: Usage;
    /**
     * latency_ms is the total wall-clock latency of the LLM call in milliseconds.
     *
     * @generated from protobuf field: int64 latency_ms = 8
     */
    latencyMs: bigint;
    /**
     * is_error indicates if the LLM call resulted in an error.
     *
     * @generated from protobuf field: bool is_error = 9
     */
    isError: boolean;
    /**
     * error_message describes the failure if is_error is true (optional).
     *
     * @generated from protobuf field: string error_message = 10
     */
    errorMessage: string;
    /**
     * completed_at is when the LLM stream closed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 11
     */
    completedAt?: Timestamp;
    /**
     * parent_event_id is the ID of the LLMCallStart event (optional).
     *
     * @generated from protobuf field: string parent_event_id = 12
     */
    parentEventId: string;
}
/**
 * SessionStartedEvent is the hook payload for HOOK_POINT_SESSION_START.
 * Fired by SessionActor once context is ready and the session gate is open.
 *
 * @generated from protobuf message agency.events.v1.SessionStartedEvent
 */
export interface SessionStartedEvent {
    /**
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * @generated from protobuf field: string user_sub = 4
     */
    userSub: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 5
     */
    startedAt?: Timestamp;
}
/**
 * SessionEndedEvent is the hook payload for HOOK_POINT_SESSION_END.
 * Fired by SessionActor in handleStopped, before resources are released.
 *
 * @generated from protobuf message agency.events.v1.SessionEndedEvent
 */
export interface SessionEndedEvent {
    /**
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * @generated from protobuf field: string user_sub = 4
     */
    userSub: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp ended_at = 5
     */
    endedAt?: Timestamp;
}
/**
 * SessionForkedEvent is the hook payload for HOOK_POINT_SESSION_FORK and is also
 * published to the child session's session-events stream as a lifecycle event.
 * Fired by WorkspaceActor after the child SessionActor is spawned.
 *
 * @generated from protobuf message agency.events.v1.SessionForkedEvent
 */
export interface SessionForkedEvent {
    /**
     * child_session_id is the newly spawned session.
     *
     * @generated from protobuf field: string child_session_id = 1
     */
    childSessionId: string;
    /**
     * parent_session_id is the source session.
     *
     * @generated from protobuf field: string parent_session_id = 2
     */
    parentSessionId: string;
    /**
     * thread_id is the shared thread (parent's thread or caller-supplied override).
     *
     * @generated from protobuf field: string thread_id = 3
     */
    threadId: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 4
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 5
     */
    workspace: string;
    /**
     * fork_turn is the turn number in the parent's history at which the fork was taken.
     *
     * @generated from protobuf field: int32 fork_turn = 6
     */
    forkTurn: number;
    /**
     * fork_seq is the resolved stream sequence in the parent's session-events stream
     * corresponding to the fork_turn TurnEnd event.
     *
     * @generated from protobuf field: uint64 fork_seq = 7
     */
    forkSeq: bigint;
    /**
     * user_sub is the user subject from the fork requester's JWT.
     *
     * @generated from protobuf field: string user_sub = 8
     */
    userSub: string;
    /**
     * forked_at is when the fork completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp forked_at = 9
     */
    forkedAt?: Timestamp;
}
/**
 * IngressEvent is the hook payload for HOOK_POINT_CONCURRENT_INGRESS_MESSAGE
 * and HOOK_POINT_CONCURRENT_INGRESS_TOOL. Published to remote hook handlers
 * when a new ingress message arrives while a turn or tool dispatch is active.
 *
 * @generated from protobuf message agency.events.v1.IngressEvent
 */
export interface IngressEvent {
    /**
     * session_id is the active session receiving the concurrent message.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant of the active session.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace of the active session.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * user_sub is the Casdoor user identity from the concurrent ingress JWT.
     *
     * @generated from protobuf field: string user_sub = 4
     */
    userSub: string;
    /**
     * payload is the user message from the concurrent ingress envelope.
     *
     * @generated from protobuf field: google.protobuf.Any payload = 5
     */
    payload?: Any;
}
/**
 * SnapshotTrigger defines what triggered a snapshot.
 *
 * @generated from protobuf enum agency.events.v1.SnapshotTrigger
 */
export enum SnapshotTrigger {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * INTERVAL_STEPS is triggered by step count threshold.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_INTERVAL_STEPS = 1;
     */
    INTERVAL_STEPS = 1,
    /**
     * INTERVAL_DURATION is triggered by time duration threshold.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_INTERVAL_DURATION = 2;
     */
    INTERVAL_DURATION = 2,
    /**
     * MANUAL is an explicit snapshot request.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_MANUAL = 3;
     */
    MANUAL = 3,
    /**
     * DRAIN is a pre-shutdown checkpoint during graceful drain.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_DRAIN = 4;
     */
    DRAIN = 4,
    /**
     * PRE_FEDERATION is before session delegation to remote harness.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_PRE_FEDERATION = 5;
     */
    PRE_FEDERATION = 5,
    /**
     * RECOVERY is after crash recovery.
     *
     * @generated from protobuf enum value: SNAPSHOT_TRIGGER_RECOVERY = 6;
     */
    RECOVERY = 6
}
/**
 * AlertLevel defines alert severity levels.
 *
 * @generated from protobuf enum agency.events.v1.AlertLevel
 */
export enum AlertLevel {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: ALERT_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * INFO is informational.
     *
     * @generated from protobuf enum value: ALERT_LEVEL_INFO = 1;
     */
    INFO = 1,
    /**
     * WARNING requires attention.
     *
     * @generated from protobuf enum value: ALERT_LEVEL_WARNING = 2;
     */
    WARNING = 2,
    /**
     * ERROR requires immediate action.
     *
     * @generated from protobuf enum value: ALERT_LEVEL_ERROR = 3;
     */
    ERROR = 3,
    /**
     * CRITICAL is a critical system issue.
     *
     * @generated from protobuf enum value: ALERT_LEVEL_CRITICAL = 4;
     */
    CRITICAL = 4
}
/**
 * CircuitBreakerState defines circuit breaker states.
 *
 * @generated from protobuf enum agency.events.v1.CircuitBreakerState
 */
export enum CircuitBreakerState {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * CLOSED allows requests through normally.
     *
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_CLOSED = 1;
     */
    CLOSED = 1,
    /**
     * OPEN blocks requests due to repeated failures.
     *
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_OPEN = 2;
     */
    OPEN = 2,
    /**
     * HALF_OPEN allows limited requests to test recovery.
     *
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_HALF_OPEN = 3;
     */
    HALF_OPEN = 3
}
/**
 * ShutdownType indicates how the harness is shutting down.
 *
 * @generated from protobuf enum agency.events.v1.ShutdownType
 */
export enum ShutdownType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SHUTDOWN_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * GRACEFUL allows in-flight operations to complete.
     *
     * @generated from protobuf enum value: SHUTDOWN_TYPE_GRACEFUL = 1;
     */
    GRACEFUL = 1,
    /**
     * IMMEDIATE terminates all operations.
     *
     * @generated from protobuf enum value: SHUTDOWN_TYPE_IMMEDIATE = 2;
     */
    IMMEDIATE = 2,
    /**
     * SUPERVISION_EXHAUSTED indicates restart limit reached.
     *
     * @generated from protobuf enum value: SHUTDOWN_TYPE_SUPERVISION_EXHAUSTED = 3;
     */
    SUPERVISION_EXHAUSTED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class TurnStart$Type extends MessageType<TurnStart> {
    constructor() {
        super("agency.events.v1.TurnStart", [
            { no: 1, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "turn_number", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 1 } } } },
            { no: 4, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 6, name: "user_content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "65536" } } } }
        ]);
    }
    create(value?: PartialMessage<TurnStart>): TurnStart {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.turnId = "";
        message.sessionId = "";
        message.turnNumber = 0;
        message.parentEventId = "";
        message.userContent = "";
        if (value !== undefined)
            reflectionMergePartial<TurnStart>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TurnStart): TurnStart {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string turn_id */ 1:
                    message.turnId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* int32 turn_number */ 3:
                    message.turnNumber = reader.int32();
                    break;
                case /* google.protobuf.Timestamp started_at */ 4:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                case /* string user_content */ 6:
                    message.userContent = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TurnStart, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string turn_id = 1; */
        if (message.turnId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.turnId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* int32 turn_number = 3; */
        if (message.turnNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.turnNumber);
        /* google.protobuf.Timestamp started_at = 4; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        /* string user_content = 6; */
        if (message.userContent !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userContent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.TurnStart
 */
export const TurnStart = new TurnStart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TurnEnd$Type extends MessageType<TurnEnd> {
    constructor() {
        super("agency.events.v1.TurnEnd", [
            { no: 1, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "assistant_message", kind: "message", T: () => Message },
            { no: 7, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 4, name: "tool_results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ToolResult, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 5, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<TurnEnd>): TurnEnd {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.turnId = "";
        message.sessionId = "";
        message.parentEventId = "";
        message.toolResults = [];
        message.tokensConsumed = 0n;
        if (value !== undefined)
            reflectionMergePartial<TurnEnd>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TurnEnd): TurnEnd {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string turn_id */ 1:
                    message.turnId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* agency.session.v1.Message assistant_message */ 3:
                    message.assistantMessage = Message.internalBinaryRead(reader, reader.uint32(), options, message.assistantMessage);
                    break;
                case /* string parent_event_id */ 7:
                    message.parentEventId = reader.string();
                    break;
                case /* repeated agency.tool.v1.ToolResult tool_results */ 4:
                    message.toolResults.push(ToolResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp completed_at */ 5:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* int64 tokens_consumed */ 6:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TurnEnd, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string turn_id = 1; */
        if (message.turnId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.turnId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* agency.session.v1.Message assistant_message = 3; */
        if (message.assistantMessage)
            Message.internalBinaryWrite(message.assistantMessage, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.tool.v1.ToolResult tool_results = 4; */
        for (let i = 0; i < message.toolResults.length; i++)
            ToolResult.internalBinaryWrite(message.toolResults[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 5; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int64 tokens_consumed = 6; */
        if (message.tokensConsumed !== 0n)
            writer.tag(6, WireType.Varint).int64(message.tokensConsumed);
        /* string parent_event_id = 7; */
        if (message.parentEventId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.TurnEnd
 */
export const TurnEnd = new TurnEnd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageStart$Type extends MessageType<MessageStart> {
    constructor() {
        super("agency.events.v1.MessageStart", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "message", kind: "message", T: () => Message, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<MessageStart>): MessageStart {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<MessageStart>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MessageStart): MessageStart {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* agency.session.v1.Message message */ 3:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* google.protobuf.Timestamp started_at */ 4:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MessageStart, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* agency.session.v1.Message message = 3; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp started_at = 4; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.MessageStart
 */
export const MessageStart = new MessageStart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageUpdate$Type extends MessageType<MessageUpdate> {
    constructor() {
        super("agency.events.v1.MessageUpdate", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "delta", kind: "message", T: () => AssistantMessageDelta, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<MessageUpdate>): MessageUpdate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<MessageUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MessageUpdate): MessageUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* agency.events.v1.AssistantMessageDelta delta */ 3:
                    message.delta = AssistantMessageDelta.internalBinaryRead(reader, reader.uint32(), options, message.delta);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 4:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MessageUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* agency.events.v1.AssistantMessageDelta delta = 3; */
        if (message.delta)
            AssistantMessageDelta.internalBinaryWrite(message.delta, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 4; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.MessageUpdate
 */
export const MessageUpdate = new MessageUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantMessageDelta$Type extends MessageType<AssistantMessageDelta> {
    constructor() {
        super("agency.events.v1.AssistantMessageDelta", [
            { no: 1, name: "text_delta", kind: "scalar", oneof: "delta", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "thinking_delta", kind: "scalar", oneof: "delta", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "toolcall_delta", kind: "scalar", oneof: "delta", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "content_index", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<AssistantMessageDelta>): AssistantMessageDelta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.delta = { oneofKind: undefined };
        message.contentIndex = 0;
        if (value !== undefined)
            reflectionMergePartial<AssistantMessageDelta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssistantMessageDelta): AssistantMessageDelta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text_delta */ 1:
                    message.delta = {
                        oneofKind: "textDelta",
                        textDelta: reader.string()
                    };
                    break;
                case /* string thinking_delta */ 2:
                    message.delta = {
                        oneofKind: "thinkingDelta",
                        thinkingDelta: reader.string()
                    };
                    break;
                case /* string toolcall_delta */ 3:
                    message.delta = {
                        oneofKind: "toolcallDelta",
                        toolcallDelta: reader.string()
                    };
                    break;
                case /* int32 content_index */ 4:
                    message.contentIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssistantMessageDelta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string text_delta = 1; */
        if (message.delta.oneofKind === "textDelta")
            writer.tag(1, WireType.LengthDelimited).string(message.delta.textDelta);
        /* string thinking_delta = 2; */
        if (message.delta.oneofKind === "thinkingDelta")
            writer.tag(2, WireType.LengthDelimited).string(message.delta.thinkingDelta);
        /* string toolcall_delta = 3; */
        if (message.delta.oneofKind === "toolcallDelta")
            writer.tag(3, WireType.LengthDelimited).string(message.delta.toolcallDelta);
        /* int32 content_index = 4; */
        if (message.contentIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.contentIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.AssistantMessageDelta
 */
export const AssistantMessageDelta = new AssistantMessageDelta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEnd$Type extends MessageType<MessageEnd> {
    constructor() {
        super("agency.events.v1.MessageEnd", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "message", kind: "message", T: () => Message, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<MessageEnd>): MessageEnd {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<MessageEnd>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MessageEnd): MessageEnd {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* agency.session.v1.Message message */ 3:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 4:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MessageEnd, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* agency.session.v1.Message message = 3; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 4; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.MessageEnd
 */
export const MessageEnd = new MessageEnd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionStart$Type extends MessageType<ToolExecutionStart> {
    constructor() {
        super("agency.events.v1.ToolExecutionStart", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "tool_call_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 5, name: "args", kind: "message", T: () => Struct, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionStart>): ToolExecutionStart {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.toolCallId = "";
        message.toolName = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionStart>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionStart): ToolExecutionStart {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* string tool_call_id */ 3:
                    message.toolCallId = reader.string();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* google.protobuf.Struct args */ 5:
                    message.args = Struct.internalBinaryRead(reader, reader.uint32(), options, message.args);
                    break;
                case /* google.protobuf.Timestamp started_at */ 6:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* string parent_event_id */ 7:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionStart, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* string tool_call_id = 3; */
        if (message.toolCallId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.toolCallId);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* google.protobuf.Struct args = 5; */
        if (message.args)
            Struct.internalBinaryWrite(message.args, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp started_at = 6; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 7; */
        if (message.parentEventId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ToolExecutionStart
 */
export const ToolExecutionStart = new ToolExecutionStart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionUpdate$Type extends MessageType<ToolExecutionUpdate> {
    constructor() {
        super("agency.events.v1.ToolExecutionUpdate", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "tool_call_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 5, name: "partial", kind: "message", T: () => ToolPartialResult, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionUpdate>): ToolExecutionUpdate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.toolCallId = "";
        message.toolName = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionUpdate): ToolExecutionUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* string tool_call_id */ 3:
                    message.toolCallId = reader.string();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* agency.tool.v1.ToolPartialResult partial */ 5:
                    message.partial = ToolPartialResult.internalBinaryRead(reader, reader.uint32(), options, message.partial);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string parent_event_id */ 7:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* string tool_call_id = 3; */
        if (message.toolCallId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.toolCallId);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* agency.tool.v1.ToolPartialResult partial = 5; */
        if (message.partial)
            ToolPartialResult.internalBinaryWrite(message.partial, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 7; */
        if (message.parentEventId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ToolExecutionUpdate
 */
export const ToolExecutionUpdate = new ToolExecutionUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionEnd$Type extends MessageType<ToolExecutionEnd> {
    constructor() {
        super("agency.events.v1.ToolExecutionEnd", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "tool_call_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 5, name: "result", kind: "message", T: () => ToolResult, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "is_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "error_class", kind: "enum", T: () => ["agency.tool.v1.ErrorClass", ErrorClass, "ERROR_CLASS_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 9, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 10, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionEnd>): ToolExecutionEnd {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.toolCallId = "";
        message.toolName = "";
        message.isError = false;
        message.errorClass = 0;
        message.errorMessage = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionEnd>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionEnd): ToolExecutionEnd {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* string tool_call_id */ 3:
                    message.toolCallId = reader.string();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* agency.tool.v1.ToolResult result */ 5:
                    message.result = ToolResult.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 6:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* bool is_error */ 7:
                    message.isError = reader.bool();
                    break;
                case /* agency.tool.v1.ErrorClass error_class */ 8:
                    message.errorClass = reader.int32();
                    break;
                case /* string error_message */ 9:
                    message.errorMessage = reader.string();
                    break;
                case /* string parent_event_id */ 10:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionEnd, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* string tool_call_id = 3; */
        if (message.toolCallId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.toolCallId);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* agency.tool.v1.ToolResult result = 5; */
        if (message.result)
            ToolResult.internalBinaryWrite(message.result, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 6; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_error = 7; */
        if (message.isError !== false)
            writer.tag(7, WireType.Varint).bool(message.isError);
        /* agency.tool.v1.ErrorClass error_class = 8; */
        if (message.errorClass !== 0)
            writer.tag(8, WireType.Varint).int32(message.errorClass);
        /* string error_message = 9; */
        if (message.errorMessage !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.errorMessage);
        /* string parent_event_id = 10; */
        if (message.parentEventId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ToolExecutionEnd
 */
export const ToolExecutionEnd = new ToolExecutionEnd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanEvent$Type extends MessageType<PlanEvent> {
    constructor() {
        super("agency.events.v1.PlanEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "goal", kind: "message", T: () => Goal, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "plan", kind: "message", T: () => Plan, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "planned_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<PlanEvent>): PlanEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<PlanEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PlanEvent): PlanEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* agency.session.v1.Goal goal */ 2:
                    message.goal = Goal.internalBinaryRead(reader, reader.uint32(), options, message.goal);
                    break;
                case /* agency.session.v1.Plan plan */ 3:
                    message.plan = Plan.internalBinaryRead(reader, reader.uint32(), options, message.plan);
                    break;
                case /* google.protobuf.Timestamp planned_at */ 4:
                    message.plannedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.plannedAt);
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PlanEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* agency.session.v1.Goal goal = 2; */
        if (message.goal)
            Goal.internalBinaryWrite(message.goal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.Plan plan = 3; */
        if (message.plan)
            Plan.internalBinaryWrite(message.plan, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp planned_at = 4; */
        if (message.plannedAt)
            Timestamp.internalBinaryWrite(message.plannedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.PlanEvent
 */
export const PlanEvent = new PlanEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepEvent$Type extends MessageType<StepEvent> {
    constructor() {
        super("agency.events.v1.StepEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "step_index", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "tool_call", kind: "message", T: () => ToolCall, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "tool_result", kind: "message", T: () => ToolResult, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<StepEvent>): StepEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.stepIndex = 0;
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<StepEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StepEvent): StepEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* int32 step_index */ 2:
                    message.stepIndex = reader.int32();
                    break;
                case /* agency.tool.v1.ToolCall tool_call */ 3:
                    message.toolCall = ToolCall.internalBinaryRead(reader, reader.uint32(), options, message.toolCall);
                    break;
                case /* agency.tool.v1.ToolResult tool_result */ 4:
                    message.toolResult = ToolResult.internalBinaryRead(reader, reader.uint32(), options, message.toolResult);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 5:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* string parent_event_id */ 6:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StepEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* int32 step_index = 2; */
        if (message.stepIndex !== 0)
            writer.tag(2, WireType.Varint).int32(message.stepIndex);
        /* agency.tool.v1.ToolCall tool_call = 3; */
        if (message.toolCall)
            ToolCall.internalBinaryWrite(message.toolCall, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolResult tool_result = 4; */
        if (message.toolResult)
            ToolResult.internalBinaryWrite(message.toolResult, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 5; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 6; */
        if (message.parentEventId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.StepEvent
 */
export const StepEvent = new StepEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SnapshotEvent$Type extends MessageType<SnapshotEvent> {
    constructor() {
        super("agency.events.v1.SnapshotEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "snapshot_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { uint64: { gte: "1" } } } },
            { no: 3, name: "inline_state", kind: "message", oneof: "payload", T: () => SessionState },
            { no: 4, name: "object_store_ref", kind: "scalar", oneof: "payload", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "snapshot_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "trigger", kind: "enum", T: () => ["agency.events.v1.SnapshotTrigger", SnapshotTrigger, "SNAPSHOT_TRIGGER_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<SnapshotEvent>): SnapshotEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.snapshotSeq = 0n;
        message.payload = { oneofKind: undefined };
        message.trigger = 0;
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<SnapshotEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SnapshotEvent): SnapshotEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* uint64 snapshot_seq */ 2:
                    message.snapshotSeq = reader.uint64().toBigInt();
                    break;
                case /* agency.session.v1.SessionState inline_state */ 3:
                    message.payload = {
                        oneofKind: "inlineState",
                        inlineState: SessionState.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).inlineState)
                    };
                    break;
                case /* string object_store_ref */ 4:
                    message.payload = {
                        oneofKind: "objectStoreRef",
                        objectStoreRef: reader.string()
                    };
                    break;
                case /* google.protobuf.Timestamp snapshot_at */ 5:
                    message.snapshotAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.snapshotAt);
                    break;
                case /* agency.events.v1.SnapshotTrigger trigger */ 6:
                    message.trigger = reader.int32();
                    break;
                case /* string parent_event_id */ 7:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SnapshotEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* uint64 snapshot_seq = 2; */
        if (message.snapshotSeq !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.snapshotSeq);
        /* agency.session.v1.SessionState inline_state = 3; */
        if (message.payload.oneofKind === "inlineState")
            SessionState.internalBinaryWrite(message.payload.inlineState, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string object_store_ref = 4; */
        if (message.payload.oneofKind === "objectStoreRef")
            writer.tag(4, WireType.LengthDelimited).string(message.payload.objectStoreRef);
        /* google.protobuf.Timestamp snapshot_at = 5; */
        if (message.snapshotAt)
            Timestamp.internalBinaryWrite(message.snapshotAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.events.v1.SnapshotTrigger trigger = 6; */
        if (message.trigger !== 0)
            writer.tag(6, WireType.Varint).int32(message.trigger);
        /* string parent_event_id = 7; */
        if (message.parentEventId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SnapshotEvent
 */
export const SnapshotEvent = new SnapshotEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentDoneEvent$Type extends MessageType<AgentDoneEvent> {
    constructor() {
        super("agency.events.v1.AgentDoneEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "final_state", kind: "message", T: () => SessionState, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "final_message", kind: "message", T: () => Message },
            { no: 4, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 6, name: "total_tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 7, name: "total_tool_calls", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 8, name: "duration_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<AgentDoneEvent>): AgentDoneEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.parentEventId = "";
        message.totalTokensConsumed = 0n;
        message.totalToolCalls = 0;
        message.durationSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<AgentDoneEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentDoneEvent): AgentDoneEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* agency.session.v1.SessionState final_state */ 2:
                    message.finalState = SessionState.internalBinaryRead(reader, reader.uint32(), options, message.finalState);
                    break;
                case /* agency.session.v1.Message final_message */ 3:
                    message.finalMessage = Message.internalBinaryRead(reader, reader.uint32(), options, message.finalMessage);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 4:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                case /* int64 total_tokens_consumed */ 6:
                    message.totalTokensConsumed = reader.int64().toBigInt();
                    break;
                case /* int32 total_tool_calls */ 7:
                    message.totalToolCalls = reader.int32();
                    break;
                case /* int64 duration_seconds */ 8:
                    message.durationSeconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentDoneEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* agency.session.v1.SessionState final_state = 2; */
        if (message.finalState)
            SessionState.internalBinaryWrite(message.finalState, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.Message final_message = 3; */
        if (message.finalMessage)
            Message.internalBinaryWrite(message.finalMessage, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 4; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        /* int64 total_tokens_consumed = 6; */
        if (message.totalTokensConsumed !== 0n)
            writer.tag(6, WireType.Varint).int64(message.totalTokensConsumed);
        /* int32 total_tool_calls = 7; */
        if (message.totalToolCalls !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalToolCalls);
        /* int64 duration_seconds = 8; */
        if (message.durationSeconds !== 0n)
            writer.tag(8, WireType.Varint).int64(message.durationSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.AgentDoneEvent
 */
export const AgentDoneEvent = new AgentDoneEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelledEvent$Type extends MessageType<CancelledEvent> {
    constructor() {
        super("agency.events.v1.CancelledEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 3, name: "cancelled_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "cancelled_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "partial_state", kind: "message", T: () => SessionState },
            { no: 6, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<CancelledEvent>): CancelledEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.reason = "";
        message.cancelledBy = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<CancelledEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CancelledEvent): CancelledEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* string cancelled_by */ 3:
                    message.cancelledBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp cancelled_at */ 4:
                    message.cancelledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.cancelledAt);
                    break;
                case /* agency.session.v1.SessionState partial_state */ 5:
                    message.partialState = SessionState.internalBinaryRead(reader, reader.uint32(), options, message.partialState);
                    break;
                case /* string parent_event_id */ 6:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CancelledEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* string cancelled_by = 3; */
        if (message.cancelledBy !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cancelledBy);
        /* google.protobuf.Timestamp cancelled_at = 4; */
        if (message.cancelledAt)
            Timestamp.internalBinaryWrite(message.cancelledAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.SessionState partial_state = 5; */
        if (message.partialState)
            SessionState.internalBinaryWrite(message.partialState, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 6; */
        if (message.parentEventId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.CancelledEvent
 */
export const CancelledEvent = new CancelledEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InterruptEvent$Type extends MessageType<InterruptEvent> {
    constructor() {
        super("agency.events.v1.InterruptEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "steering_messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10" } } } },
            { no: 3, name: "interrupted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 5, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<InterruptEvent>): InterruptEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.steeringMessages = [];
        message.reason = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<InterruptEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InterruptEvent): InterruptEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* repeated agency.session.v1.Message steering_messages */ 2:
                    message.steeringMessages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp interrupted_at */ 3:
                    message.interruptedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.interruptedAt);
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* string parent_event_id */ 5:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InterruptEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* repeated agency.session.v1.Message steering_messages = 2; */
        for (let i = 0; i < message.steeringMessages.length; i++)
            Message.internalBinaryWrite(message.steeringMessages[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp interrupted_at = 3; */
        if (message.interruptedAt)
            Timestamp.internalBinaryWrite(message.interruptedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* string parent_event_id = 5; */
        if (message.parentEventId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.InterruptEvent
 */
export const InterruptEvent = new InterruptEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionFailedEvent$Type extends MessageType<SessionFailedEvent> {
    constructor() {
        super("agency.events.v1.SessionFailedEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 3, name: "error_class", kind: "enum", T: () => ["agency.tool.v1.ErrorClass", ErrorClass, "ERROR_CLASS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0, 1] } } } },
            { no: 4, name: "failed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "partial_state", kind: "message", T: () => SessionState },
            { no: 6, name: "stack_trace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "16384" } } } },
            { no: 7, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<SessionFailedEvent>): SessionFailedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.errorMessage = "";
        message.errorClass = 0;
        message.stackTrace = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<SessionFailedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionFailedEvent): SessionFailedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* agency.tool.v1.ErrorClass error_class */ 3:
                    message.errorClass = reader.int32();
                    break;
                case /* google.protobuf.Timestamp failed_at */ 4:
                    message.failedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.failedAt);
                    break;
                case /* agency.session.v1.SessionState partial_state */ 5:
                    message.partialState = SessionState.internalBinaryRead(reader, reader.uint32(), options, message.partialState);
                    break;
                case /* string stack_trace */ 6:
                    message.stackTrace = reader.string();
                    break;
                case /* string parent_event_id */ 7:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionFailedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* agency.tool.v1.ErrorClass error_class = 3; */
        if (message.errorClass !== 0)
            writer.tag(3, WireType.Varint).int32(message.errorClass);
        /* google.protobuf.Timestamp failed_at = 4; */
        if (message.failedAt)
            Timestamp.internalBinaryWrite(message.failedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.SessionState partial_state = 5; */
        if (message.partialState)
            SessionState.internalBinaryWrite(message.partialState, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string stack_trace = 6; */
        if (message.stackTrace !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.stackTrace);
        /* string parent_event_id = 7; */
        if (message.parentEventId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SessionFailedEvent
 */
export const SessionFailedEvent = new SessionFailedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextUpdated$Type extends MessageType<ContextUpdated> {
    constructor() {
        super("agency.events.v1.ContextUpdated", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "stage", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "revision", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "bundle", kind: "message", T: () => ContextBundle }
        ]);
    }
    create(value?: PartialMessage<ContextUpdated>): ContextUpdated {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.stage = "";
        message.revision = 0n;
        if (value !== undefined)
            reflectionMergePartial<ContextUpdated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextUpdated): ContextUpdated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string stage */ 3:
                    message.stage = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* uint64 revision */ 5:
                    message.revision = reader.uint64().toBigInt();
                    break;
                case /* agency.context.v1.ContextBundle bundle */ 6:
                    message.bundle = ContextBundle.internalBinaryRead(reader, reader.uint32(), options, message.bundle);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextUpdated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string stage = 3; */
        if (message.stage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.stage);
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* uint64 revision = 5; */
        if (message.revision !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.revision);
        /* agency.context.v1.ContextBundle bundle = 6; */
        if (message.bundle)
            ContextBundle.internalBinaryWrite(message.bundle, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ContextUpdated
 */
export const ContextUpdated = new ContextUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextReady$Type extends MessageType<ContextReady> {
    constructor() {
        super("agency.events.v1.ContextReady", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "ready_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "stages_loaded", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 5, name: "bundle", kind: "message", T: () => ContextBundle }
        ]);
    }
    create(value?: PartialMessage<ContextReady>): ContextReady {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.stagesLoaded = [];
        if (value !== undefined)
            reflectionMergePartial<ContextReady>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextReady): ContextReady {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* google.protobuf.Timestamp ready_at */ 3:
                    message.readyAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.readyAt);
                    break;
                case /* repeated string stages_loaded */ 4:
                    message.stagesLoaded.push(reader.string());
                    break;
                case /* agency.context.v1.ContextBundle bundle */ 5:
                    message.bundle = ContextBundle.internalBinaryRead(reader, reader.uint32(), options, message.bundle);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextReady, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* google.protobuf.Timestamp ready_at = 3; */
        if (message.readyAt)
            Timestamp.internalBinaryWrite(message.readyAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string stages_loaded = 4; */
        for (let i = 0; i < message.stagesLoaded.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.stagesLoaded[i]);
        /* agency.context.v1.ContextBundle bundle = 5; */
        if (message.bundle)
            ContextBundle.internalBinaryWrite(message.bundle, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ContextReady
 */
export const ContextReady = new ContextReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArtifactUpdated$Type extends MessageType<ArtifactUpdated> {
    constructor() {
        super("agency.events.v1.ArtifactUpdated", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "artifact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "artifact_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "object_store_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 7, name: "size_bytes", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<ArtifactUpdated>): ArtifactUpdated {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.artifactId = "";
        message.artifactType = "";
        message.objectStorePath = "";
        message.sizeBytes = 0n;
        if (value !== undefined)
            reflectionMergePartial<ArtifactUpdated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArtifactUpdated): ArtifactUpdated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string artifact_id */ 3:
                    message.artifactId = reader.string();
                    break;
                case /* string artifact_type */ 4:
                    message.artifactType = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string object_store_path */ 6:
                    message.objectStorePath = reader.string();
                    break;
                case /* int64 size_bytes */ 7:
                    message.sizeBytes = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ArtifactUpdated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string artifact_id = 3; */
        if (message.artifactId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.artifactId);
        /* string artifact_type = 4; */
        if (message.artifactType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.artifactType);
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string object_store_path = 6; */
        if (message.objectStorePath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.objectStorePath);
        /* int64 size_bytes = 7; */
        if (message.sizeBytes !== 0n)
            writer.tag(7, WireType.Varint).int64(message.sizeBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ArtifactUpdated
 */
export const ArtifactUpdated = new ArtifactUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArtifactUploadRequest$Type extends MessageType<ArtifactUploadRequest> {
    constructor() {
        super("agency.events.v1.ArtifactUploadRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "artifact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "artifact_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 5, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 7, name: "ttl_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<ArtifactUploadRequest>): ArtifactUploadRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.artifactId = "";
        message.artifactType = "";
        message.contentType = "";
        message.metadata = {};
        message.ttlSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<ArtifactUploadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArtifactUploadRequest): ArtifactUploadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string artifact_id */ 3:
                    message.artifactId = reader.string();
                    break;
                case /* string artifact_type */ 4:
                    message.artifactType = reader.string();
                    break;
                case /* string content_type */ 5:
                    message.contentType = reader.string();
                    break;
                case /* map<string, string> metadata */ 6:
                    this.binaryReadMap6(message.metadata, reader, options);
                    break;
                case /* int64 ttl_seconds */ 7:
                    message.ttlSeconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: ArtifactUploadRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ArtifactUploadRequest["metadata"] | undefined, val: ArtifactUploadRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.events.v1.ArtifactUploadRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ArtifactUploadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string artifact_id = 3; */
        if (message.artifactId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.artifactId);
        /* string artifact_type = 4; */
        if (message.artifactType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.artifactType);
        /* string content_type = 5; */
        if (message.contentType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.contentType);
        /* map<string, string> metadata = 6; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* int64 ttl_seconds = 7; */
        if (message.ttlSeconds !== 0n)
            writer.tag(7, WireType.Varint).int64(message.ttlSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ArtifactUploadRequest
 */
export const ArtifactUploadRequest = new ArtifactUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArtifactDownloadRequest$Type extends MessageType<ArtifactDownloadRequest> {
    constructor() {
        super("agency.events.v1.ArtifactDownloadRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "artifact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } },
            { no: 5, name: "include_metadata", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ArtifactDownloadRequest>): ArtifactDownloadRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.artifactId = "";
        message.version = "";
        message.includeMetadata = false;
        if (value !== undefined)
            reflectionMergePartial<ArtifactDownloadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArtifactDownloadRequest): ArtifactDownloadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string artifact_id */ 3:
                    message.artifactId = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                case /* bool include_metadata */ 5:
                    message.includeMetadata = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ArtifactDownloadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string artifact_id = 3; */
        if (message.artifactId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.artifactId);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        /* bool include_metadata = 5; */
        if (message.includeMetadata !== false)
            writer.tag(5, WireType.Varint).bool(message.includeMetadata);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ArtifactDownloadRequest
 */
export const ArtifactDownloadRequest = new ArtifactDownloadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArtifactMetadata$Type extends MessageType<ArtifactMetadata> {
    constructor() {
        super("agency.events.v1.ArtifactMetadata", [
            { no: 1, name: "artifact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "artifact_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "object_store_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "size_bytes", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "checksum", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "32", maxLen: "128" } } } },
            { no: 6, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } },
            { no: 11, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 12, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 13, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ArtifactMetadata>): ArtifactMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.artifactId = "";
        message.artifactType = "";
        message.objectStorePath = "";
        message.sizeBytes = 0n;
        message.checksum = "";
        message.contentType = "";
        message.version = "";
        message.metadata = {};
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<ArtifactMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArtifactMetadata): ArtifactMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string artifact_id */ 1:
                    message.artifactId = reader.string();
                    break;
                case /* string artifact_type */ 2:
                    message.artifactType = reader.string();
                    break;
                case /* string object_store_path */ 3:
                    message.objectStorePath = reader.string();
                    break;
                case /* int64 size_bytes */ 4:
                    message.sizeBytes = reader.int64().toBigInt();
                    break;
                case /* string checksum */ 5:
                    message.checksum = reader.string();
                    break;
                case /* string content_type */ 6:
                    message.contentType = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 9:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* string version */ 10:
                    message.version = reader.string();
                    break;
                case /* map<string, string> metadata */ 11:
                    this.binaryReadMap11(message.metadata, reader, options);
                    break;
                case /* string tenant */ 12:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 13:
                    message.workspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap11(map: ArtifactMetadata["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ArtifactMetadata["metadata"] | undefined, val: ArtifactMetadata["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.events.v1.ArtifactMetadata.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ArtifactMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string artifact_id = 1; */
        if (message.artifactId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.artifactId);
        /* string artifact_type = 2; */
        if (message.artifactType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.artifactType);
        /* string object_store_path = 3; */
        if (message.objectStorePath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.objectStorePath);
        /* int64 size_bytes = 4; */
        if (message.sizeBytes !== 0n)
            writer.tag(4, WireType.Varint).int64(message.sizeBytes);
        /* string checksum = 5; */
        if (message.checksum !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.checksum);
        /* string content_type = 6; */
        if (message.contentType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.contentType);
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 9; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string version = 10; */
        if (message.version !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.version);
        /* map<string, string> metadata = 11; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string tenant = 12; */
        if (message.tenant !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 13; */
        if (message.workspace !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.workspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ArtifactMetadata
 */
export const ArtifactMetadata = new ArtifactMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArtifactInvalidationEvent$Type extends MessageType<ArtifactInvalidationEvent> {
    constructor() {
        super("agency.events.v1.ArtifactInvalidationEvent", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "artifact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "invalidation_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "invalidated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "affected_versions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { maxLen: "64" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ArtifactInvalidationEvent>): ArtifactInvalidationEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.artifactId = "";
        message.invalidationReason = "";
        message.affectedVersions = [];
        if (value !== undefined)
            reflectionMergePartial<ArtifactInvalidationEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArtifactInvalidationEvent): ArtifactInvalidationEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string artifact_id */ 3:
                    message.artifactId = reader.string();
                    break;
                case /* string invalidation_reason */ 4:
                    message.invalidationReason = reader.string();
                    break;
                case /* google.protobuf.Timestamp invalidated_at */ 5:
                    message.invalidatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.invalidatedAt);
                    break;
                case /* repeated string affected_versions */ 6:
                    message.affectedVersions.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ArtifactInvalidationEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string artifact_id = 3; */
        if (message.artifactId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.artifactId);
        /* string invalidation_reason = 4; */
        if (message.invalidationReason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.invalidationReason);
        /* google.protobuf.Timestamp invalidated_at = 5; */
        if (message.invalidatedAt)
            Timestamp.internalBinaryWrite(message.invalidatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated string affected_versions = 6; */
        for (let i = 0; i < message.affectedVersions.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.affectedVersions[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ArtifactInvalidationEvent
 */
export const ArtifactInvalidationEvent = new ArtifactInvalidationEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallFrequencyExceededEvent$Type extends MessageType<ToolCallFrequencyExceededEvent> {
    constructor() {
        super("agency.events.v1.ToolCallFrequencyExceededEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 5, name: "current_frequency", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 1 } } } },
            { no: 7, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "error_class", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32", pattern: "^(ERROR_TRANSIENT|ERROR_PERMANENT|ERROR_DEGRADED)$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolCallFrequencyExceededEvent>): ToolCallFrequencyExceededEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.toolName = "";
        message.currentFrequency = 0;
        message.limit = 0;
        message.errorClass = "";
        if (value !== undefined)
            reflectionMergePartial<ToolCallFrequencyExceededEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallFrequencyExceededEvent): ToolCallFrequencyExceededEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* int32 current_frequency */ 5:
                    message.currentFrequency = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 7:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                case /* string error_class */ 8:
                    message.errorClass = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallFrequencyExceededEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* int32 current_frequency = 5; */
        if (message.currentFrequency !== 0)
            writer.tag(5, WireType.Varint).int32(message.currentFrequency);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* google.protobuf.Timestamp occurred_at = 7; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string error_class = 8; */
        if (message.errorClass !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.errorClass);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ToolCallFrequencyExceededEvent
 */
export const ToolCallFrequencyExceededEvent = new ToolCallFrequencyExceededEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RateLimitedEvent$Type extends MessageType<RateLimitedEvent> {
    constructor() {
        super("agency.events.v1.RateLimitedEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "limit_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 5, name: "current_rate", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "limit", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "1" } } } },
            { no: 7, name: "retry_after_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 8, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RateLimitedEvent>): RateLimitedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.limitType = "";
        message.currentRate = 0n;
        message.limit = 0n;
        message.retryAfterMs = 0n;
        if (value !== undefined)
            reflectionMergePartial<RateLimitedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RateLimitedEvent): RateLimitedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string limit_type */ 4:
                    message.limitType = reader.string();
                    break;
                case /* int64 current_rate */ 5:
                    message.currentRate = reader.int64().toBigInt();
                    break;
                case /* int64 limit */ 6:
                    message.limit = reader.int64().toBigInt();
                    break;
                case /* int64 retry_after_ms */ 7:
                    message.retryAfterMs = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 8:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RateLimitedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string limit_type = 4; */
        if (message.limitType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.limitType);
        /* int64 current_rate = 5; */
        if (message.currentRate !== 0n)
            writer.tag(5, WireType.Varint).int64(message.currentRate);
        /* int64 limit = 6; */
        if (message.limit !== 0n)
            writer.tag(6, WireType.Varint).int64(message.limit);
        /* int64 retry_after_ms = 7; */
        if (message.retryAfterMs !== 0n)
            writer.tag(7, WireType.Varint).int64(message.retryAfterMs);
        /* google.protobuf.Timestamp occurred_at = 8; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.RateLimitedEvent
 */
export const RateLimitedEvent = new RateLimitedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HarnessReadyEvent$Type extends MessageType<HarnessReadyEvent> {
    constructor() {
        super("agency.events.v1.HarnessReadyEvent", [
            { no: 1, name: "harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "node_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "ready_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "startup_duration_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "actor_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<HarnessReadyEvent>): HarnessReadyEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessId = "";
        message.nodeId = "";
        message.startupDurationMs = 0n;
        message.actorCount = 0;
        if (value !== undefined)
            reflectionMergePartial<HarnessReadyEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HarnessReadyEvent): HarnessReadyEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string harness_id */ 1:
                    message.harnessId = reader.string();
                    break;
                case /* string node_id */ 2:
                    message.nodeId = reader.string();
                    break;
                case /* google.protobuf.Timestamp ready_at */ 3:
                    message.readyAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.readyAt);
                    break;
                case /* int64 startup_duration_ms */ 4:
                    message.startupDurationMs = reader.int64().toBigInt();
                    break;
                case /* int32 actor_count */ 5:
                    message.actorCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HarnessReadyEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string harness_id = 1; */
        if (message.harnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.harnessId);
        /* string node_id = 2; */
        if (message.nodeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nodeId);
        /* google.protobuf.Timestamp ready_at = 3; */
        if (message.readyAt)
            Timestamp.internalBinaryWrite(message.readyAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 startup_duration_ms = 4; */
        if (message.startupDurationMs !== 0n)
            writer.tag(4, WireType.Varint).int64(message.startupDurationMs);
        /* int32 actor_count = 5; */
        if (message.actorCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.actorCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.HarnessReadyEvent
 */
export const HarnessReadyEvent = new HarnessReadyEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolRejectionEvent$Type extends MessageType<ToolRejectionEvent> {
    constructor() {
        super("agency.events.v1.ToolRejectionEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 5, name: "rejection_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 6, name: "rejection_stage", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^(VALIDATION|HOOK|SANITIZATION|AUTHORIZATION)$" } } } },
            { no: 7, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolRejectionEvent>): ToolRejectionEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.toolName = "";
        message.rejectionReason = "";
        message.rejectionStage = "";
        if (value !== undefined)
            reflectionMergePartial<ToolRejectionEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolRejectionEvent): ToolRejectionEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* string rejection_reason */ 5:
                    message.rejectionReason = reader.string();
                    break;
                case /* string rejection_stage */ 6:
                    message.rejectionStage = reader.string();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 7:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolRejectionEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* string rejection_reason = 5; */
        if (message.rejectionReason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.rejectionReason);
        /* string rejection_stage = 6; */
        if (message.rejectionStage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.rejectionStage);
        /* google.protobuf.Timestamp occurred_at = 7; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ToolRejectionEvent
 */
export const ToolRejectionEvent = new ToolRejectionEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillExecutionEvent$Type extends MessageType<SkillExecutionEvent> {
    constructor() {
        super("agency.events.v1.SkillExecutionEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "skill_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "trust_level", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32" } } } },
            { no: 4, name: "executed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<SkillExecutionEvent>): SkillExecutionEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.skillId = "";
        message.trustLevel = "";
        message.executionTimeMs = 0n;
        message.success = false;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<SkillExecutionEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillExecutionEvent): SkillExecutionEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string skill_id */ 2:
                    message.skillId = reader.string();
                    break;
                case /* string trust_level */ 3:
                    message.trustLevel = reader.string();
                    break;
                case /* google.protobuf.Timestamp executed_at */ 4:
                    message.executedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.executedAt);
                    break;
                case /* int64 execution_time_ms */ 5:
                    message.executionTimeMs = reader.int64().toBigInt();
                    break;
                case /* bool success */ 6:
                    message.success = reader.bool();
                    break;
                case /* string error_message */ 7:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SkillExecutionEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string skill_id = 2; */
        if (message.skillId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.skillId);
        /* string trust_level = 3; */
        if (message.trustLevel !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.trustLevel);
        /* google.protobuf.Timestamp executed_at = 4; */
        if (message.executedAt)
            Timestamp.internalBinaryWrite(message.executedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int64 execution_time_ms = 5; */
        if (message.executionTimeMs !== 0n)
            writer.tag(5, WireType.Varint).int64(message.executionTimeMs);
        /* bool success = 6; */
        if (message.success !== false)
            writer.tag(6, WireType.Varint).bool(message.success);
        /* string error_message = 7; */
        if (message.errorMessage !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SkillExecutionEvent
 */
export const SkillExecutionEvent = new SkillExecutionEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionStartFailedEvent$Type extends MessageType<SessionStartFailedEvent> {
    constructor() {
        super("agency.events.v1.SessionStartFailedEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 5, name: "failed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SessionStartFailedEvent>): SessionStartFailedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<SessionStartFailedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionStartFailedEvent): SessionStartFailedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp failed_at */ 5:
                    message.failedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.failedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionStartFailedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp failed_at = 5; */
        if (message.failedAt)
            Timestamp.internalBinaryWrite(message.failedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SessionStartFailedEvent
 */
export const SessionStartFailedEvent = new SessionStartFailedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DLQAlertEvent$Type extends MessageType<DLQAlertEvent> {
    constructor() {
        super("agency.events.v1.DLQAlertEvent", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "dlq_message_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "threshold_exceeded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "alert_level", kind: "enum", T: () => ["agency.events.v1.AlertLevel", AlertLevel, "ALERT_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 6, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 7, name: "alerted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "sample_message_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "256" } } } } } }
        ]);
    }
    create(value?: PartialMessage<DLQAlertEvent>): DLQAlertEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.dlqMessageCount = 0n;
        message.thresholdExceeded = false;
        message.alertLevel = 0;
        message.reason = "";
        message.sampleMessageIds = [];
        if (value !== undefined)
            reflectionMergePartial<DLQAlertEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DLQAlertEvent): DLQAlertEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* uint64 dlq_message_count */ 3:
                    message.dlqMessageCount = reader.uint64().toBigInt();
                    break;
                case /* bool threshold_exceeded */ 4:
                    message.thresholdExceeded = reader.bool();
                    break;
                case /* agency.events.v1.AlertLevel alert_level */ 5:
                    message.alertLevel = reader.int32();
                    break;
                case /* string reason */ 6:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp alerted_at */ 7:
                    message.alertedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.alertedAt);
                    break;
                case /* repeated string sample_message_ids */ 8:
                    message.sampleMessageIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DLQAlertEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* uint64 dlq_message_count = 3; */
        if (message.dlqMessageCount !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.dlqMessageCount);
        /* bool threshold_exceeded = 4; */
        if (message.thresholdExceeded !== false)
            writer.tag(4, WireType.Varint).bool(message.thresholdExceeded);
        /* agency.events.v1.AlertLevel alert_level = 5; */
        if (message.alertLevel !== 0)
            writer.tag(5, WireType.Varint).int32(message.alertLevel);
        /* string reason = 6; */
        if (message.reason !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp alerted_at = 7; */
        if (message.alertedAt)
            Timestamp.internalBinaryWrite(message.alertedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated string sample_message_ids = 8; */
        for (let i = 0; i < message.sampleMessageIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.sampleMessageIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.DLQAlertEvent
 */
export const DLQAlertEvent = new DLQAlertEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestFailedEvent$Type extends MessageType<RequestFailedEvent> {
    constructor() {
        super("agency.events.v1.RequestFailedEvent", [
            { no: 1, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "failure_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 6, name: "failure_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[A-Z0-9_]+$" } } } },
            { no: 7, name: "retry_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "retryable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "failed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "dlq_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestFailedEvent>): RequestFailedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestId = "";
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.failureReason = "";
        message.failureCode = "";
        message.retryCount = 0;
        message.retryable = false;
        message.dlqSubject = "";
        if (value !== undefined)
            reflectionMergePartial<RequestFailedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestFailedEvent): RequestFailedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_id */ 1:
                    message.requestId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string failure_reason */ 5:
                    message.failureReason = reader.string();
                    break;
                case /* string failure_code */ 6:
                    message.failureCode = reader.string();
                    break;
                case /* uint32 retry_count */ 7:
                    message.retryCount = reader.uint32();
                    break;
                case /* bool retryable */ 8:
                    message.retryable = reader.bool();
                    break;
                case /* google.protobuf.Timestamp failed_at */ 9:
                    message.failedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.failedAt);
                    break;
                case /* string dlq_subject */ 10:
                    message.dlqSubject = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestFailedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_id = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string failure_reason = 5; */
        if (message.failureReason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.failureReason);
        /* string failure_code = 6; */
        if (message.failureCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.failureCode);
        /* uint32 retry_count = 7; */
        if (message.retryCount !== 0)
            writer.tag(7, WireType.Varint).uint32(message.retryCount);
        /* bool retryable = 8; */
        if (message.retryable !== false)
            writer.tag(8, WireType.Varint).bool(message.retryable);
        /* google.protobuf.Timestamp failed_at = 9; */
        if (message.failedAt)
            Timestamp.internalBinaryWrite(message.failedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string dlq_subject = 10; */
        if (message.dlqSubject !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.dlqSubject);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.RequestFailedEvent
 */
export const RequestFailedEvent = new RequestFailedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelFallbackEvent$Type extends MessageType<ModelFallbackEvent> {
    constructor() {
        super("agency.events.v1.ModelFallbackEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "primary_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "fallback_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 4, name: "failure_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "1024" } } } },
            { no: 5, name: "fallback_position", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 0 } } } },
            { no: 6, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 8, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<ModelFallbackEvent>): ModelFallbackEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.primaryModelId = "";
        message.fallbackModelId = "";
        message.failureReason = "";
        message.fallbackPosition = 0;
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<ModelFallbackEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelFallbackEvent): ModelFallbackEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string primary_model_id */ 2:
                    message.primaryModelId = reader.string();
                    break;
                case /* string fallback_model_id */ 3:
                    message.fallbackModelId = reader.string();
                    break;
                case /* string failure_reason */ 4:
                    message.failureReason = reader.string();
                    break;
                case /* int32 fallback_position */ 5:
                    message.fallbackPosition = reader.int32();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 6:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                case /* string tenant */ 7:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 8:
                    message.workspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelFallbackEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string primary_model_id = 2; */
        if (message.primaryModelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.primaryModelId);
        /* string fallback_model_id = 3; */
        if (message.fallbackModelId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fallbackModelId);
        /* string failure_reason = 4; */
        if (message.failureReason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.failureReason);
        /* int32 fallback_position = 5; */
        if (message.fallbackPosition !== 0)
            writer.tag(5, WireType.Varint).int32(message.fallbackPosition);
        /* google.protobuf.Timestamp occurred_at = 6; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 7; */
        if (message.tenant !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 8; */
        if (message.workspace !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.workspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ModelFallbackEvent
 */
export const ModelFallbackEvent = new ModelFallbackEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelCircuitBreakerStateChange$Type extends MessageType<ModelCircuitBreakerStateChange> {
    constructor() {
        super("agency.events.v1.ModelCircuitBreakerStateChange", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "previous_state", kind: "enum", T: () => ["agency.events.v1.CircuitBreakerState", CircuitBreakerState, "CIRCUIT_BREAKER_STATE_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 4, name: "new_state", kind: "enum", T: () => ["agency.events.v1.CircuitBreakerState", CircuitBreakerState, "CIRCUIT_BREAKER_STATE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "failure_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "success_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "changed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 9, name: "recovery_time_estimate_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<ModelCircuitBreakerStateChange>): ModelCircuitBreakerStateChange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.modelId = "";
        message.provider = "";
        message.previousState = 0;
        message.newState = 0;
        message.failureCount = 0;
        message.successCount = 0;
        message.reason = "";
        message.recoveryTimeEstimateSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<ModelCircuitBreakerStateChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelCircuitBreakerStateChange): ModelCircuitBreakerStateChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* string provider */ 2:
                    message.provider = reader.string();
                    break;
                case /* agency.events.v1.CircuitBreakerState previous_state */ 3:
                    message.previousState = reader.int32();
                    break;
                case /* agency.events.v1.CircuitBreakerState new_state */ 4:
                    message.newState = reader.int32();
                    break;
                case /* uint32 failure_count */ 5:
                    message.failureCount = reader.uint32();
                    break;
                case /* uint32 success_count */ 6:
                    message.successCount = reader.uint32();
                    break;
                case /* google.protobuf.Timestamp changed_at */ 7:
                    message.changedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.changedAt);
                    break;
                case /* string reason */ 8:
                    message.reason = reader.string();
                    break;
                case /* int64 recovery_time_estimate_seconds */ 9:
                    message.recoveryTimeEstimateSeconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelCircuitBreakerStateChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* string provider = 2; */
        if (message.provider !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.provider);
        /* agency.events.v1.CircuitBreakerState previous_state = 3; */
        if (message.previousState !== 0)
            writer.tag(3, WireType.Varint).int32(message.previousState);
        /* agency.events.v1.CircuitBreakerState new_state = 4; */
        if (message.newState !== 0)
            writer.tag(4, WireType.Varint).int32(message.newState);
        /* uint32 failure_count = 5; */
        if (message.failureCount !== 0)
            writer.tag(5, WireType.Varint).uint32(message.failureCount);
        /* uint32 success_count = 6; */
        if (message.successCount !== 0)
            writer.tag(6, WireType.Varint).uint32(message.successCount);
        /* google.protobuf.Timestamp changed_at = 7; */
        if (message.changedAt)
            Timestamp.internalBinaryWrite(message.changedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 8; */
        if (message.reason !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.reason);
        /* int64 recovery_time_estimate_seconds = 9; */
        if (message.recoveryTimeEstimateSeconds !== 0n)
            writer.tag(9, WireType.Varint).int64(message.recoveryTimeEstimateSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ModelCircuitBreakerStateChange
 */
export const ModelCircuitBreakerStateChange = new ModelCircuitBreakerStateChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HarnessShutdownEvent$Type extends MessageType<HarnessShutdownEvent> {
    constructor() {
        super("agency.events.v1.HarnessShutdownEvent", [
            { no: 1, name: "harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "1024" } } } },
            { no: 3, name: "shutdown_type", kind: "enum", T: () => ["agency.events.v1.ShutdownType", ShutdownType, "SHUTDOWN_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "active_sessions", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "shutdown_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "drain_timeout_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<HarnessShutdownEvent>): HarnessShutdownEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessId = "";
        message.reason = "";
        message.shutdownType = 0;
        message.activeSessions = 0;
        message.drainTimeoutSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial<HarnessShutdownEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HarnessShutdownEvent): HarnessShutdownEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string harness_id */ 1:
                    message.harnessId = reader.string();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* agency.events.v1.ShutdownType shutdown_type */ 3:
                    message.shutdownType = reader.int32();
                    break;
                case /* int32 active_sessions */ 4:
                    message.activeSessions = reader.int32();
                    break;
                case /* google.protobuf.Timestamp shutdown_at */ 5:
                    message.shutdownAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.shutdownAt);
                    break;
                case /* int32 drain_timeout_seconds */ 6:
                    message.drainTimeoutSeconds = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HarnessShutdownEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string harness_id = 1; */
        if (message.harnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.harnessId);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* agency.events.v1.ShutdownType shutdown_type = 3; */
        if (message.shutdownType !== 0)
            writer.tag(3, WireType.Varint).int32(message.shutdownType);
        /* int32 active_sessions = 4; */
        if (message.activeSessions !== 0)
            writer.tag(4, WireType.Varint).int32(message.activeSessions);
        /* google.protobuf.Timestamp shutdown_at = 5; */
        if (message.shutdownAt)
            Timestamp.internalBinaryWrite(message.shutdownAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 drain_timeout_seconds = 6; */
        if (message.drainTimeoutSeconds !== 0)
            writer.tag(6, WireType.Varint).int32(message.drainTimeoutSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.HarnessShutdownEvent
 */
export const HarnessShutdownEvent = new HarnessShutdownEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenantContextEvent$Type extends MessageType<TenantContextEvent> {
    constructor() {
        super("agency.events.v1.TenantContextEvent", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "context_data", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "65536" } } } } } },
            { no: 3, name: "source_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "injected_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "delegation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<TenantContextEvent>): TenantContextEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.contextData = {};
        message.sourceHarnessId = "";
        message.delegationId = "";
        if (value !== undefined)
            reflectionMergePartial<TenantContextEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenantContextEvent): TenantContextEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* map<string, string> context_data */ 2:
                    this.binaryReadMap2(message.contextData, reader, options);
                    break;
                case /* string source_harness_id */ 3:
                    message.sourceHarnessId = reader.string();
                    break;
                case /* google.protobuf.Timestamp injected_at */ 4:
                    message.injectedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.injectedAt);
                    break;
                case /* string delegation_id */ 5:
                    message.delegationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: TenantContextEvent["contextData"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TenantContextEvent["contextData"] | undefined, val: TenantContextEvent["contextData"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.events.v1.TenantContextEvent.context_data");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: TenantContextEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* map<string, string> context_data = 2; */
        for (let k of globalThis.Object.keys(message.contextData))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.contextData[k]).join();
        /* string source_harness_id = 3; */
        if (message.sourceHarnessId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sourceHarnessId);
        /* google.protobuf.Timestamp injected_at = 4; */
        if (message.injectedAt)
            Timestamp.internalBinaryWrite(message.injectedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string delegation_id = 5; */
        if (message.delegationId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.delegationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.TenantContextEvent
 */
export const TenantContextEvent = new TenantContextEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorSpawnFailedEvent$Type extends MessageType<ActorSpawnFailedEvent> {
    constructor() {
        super("agency.events.v1.ActorSpawnFailedEvent", [
            { no: 1, name: "urn", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1" } } } },
            { no: 2, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1" } } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1" } } } },
            { no: 4, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ActorSpawnFailedEvent>): ActorSpawnFailedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.urn = "";
        message.role = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<ActorSpawnFailedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorSpawnFailedEvent): ActorSpawnFailedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string urn */ 1:
                    message.urn = reader.string();
                    break;
                case /* string role */ 2:
                    message.role = reader.string();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 4:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorSpawnFailedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string urn = 1; */
        if (message.urn !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.urn);
        /* string role = 2; */
        if (message.role !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.role);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp timestamp = 4; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.ActorSpawnFailedEvent
 */
export const ActorSpawnFailedEvent = new ActorSpawnFailedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenCount$Type extends MessageType<TokenCount> {
    constructor() {
        super("agency.events.v1.TokenCount", [
            { no: 1, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 2, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 3, name: "cached_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 4, name: "total_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<TokenCount>): TokenCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inputTokens = 0n;
        message.outputTokens = 0n;
        message.cachedTokens = 0n;
        message.totalTokens = 0n;
        if (value !== undefined)
            reflectionMergePartial<TokenCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TokenCount): TokenCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 input_tokens */ 1:
                    message.inputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 output_tokens */ 2:
                    message.outputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 cached_tokens */ 3:
                    message.cachedTokens = reader.int64().toBigInt();
                    break;
                case /* int64 total_tokens */ 4:
                    message.totalTokens = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TokenCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 input_tokens = 1; */
        if (message.inputTokens !== 0n)
            writer.tag(1, WireType.Varint).int64(message.inputTokens);
        /* int64 output_tokens = 2; */
        if (message.outputTokens !== 0n)
            writer.tag(2, WireType.Varint).int64(message.outputTokens);
        /* int64 cached_tokens = 3; */
        if (message.cachedTokens !== 0n)
            writer.tag(3, WireType.Varint).int64(message.cachedTokens);
        /* int64 total_tokens = 4; */
        if (message.totalTokens !== 0n)
            writer.tag(4, WireType.Varint).int64(message.totalTokens);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.TokenCount
 */
export const TokenCount = new TokenCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LLMCallStart$Type extends MessageType<LLMCallStart> {
    constructor() {
        super("agency.events.v1.LLMCallStart", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 5, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "request", kind: "message", T: () => InferRequest, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<LLMCallStart>): LLMCallStart {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.tenant = "";
        message.workspace = "";
        message.modelId = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<LLMCallStart>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LLMCallStart): LLMCallStart {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string model_id */ 5:
                    message.modelId = reader.string();
                    break;
                case /* agency.infer.v1.InferRequest request */ 6:
                    message.request = InferRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* google.protobuf.Timestamp started_at */ 7:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* string parent_event_id */ 8:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LLMCallStart, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string model_id = 5; */
        if (message.modelId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.modelId);
        /* agency.infer.v1.InferRequest request = 6; */
        if (message.request)
            InferRequest.internalBinaryWrite(message.request, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp started_at = 7; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 8; */
        if (message.parentEventId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.LLMCallStart
 */
export const LLMCallStart = new LLMCallStart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LLMCallEnd$Type extends MessageType<LLMCallEnd> {
    constructor() {
        super("agency.events.v1.LLMCallEnd", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 5, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "finish_reason", kind: "enum", T: () => ["agency.infer.v1.FinishReason", FinishReason, "FINISH_REASON_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "usage", kind: "message", T: () => Usage, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "latency_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 9, name: "is_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 11, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 12, name: "parent_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<LLMCallEnd>): LLMCallEnd {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.tenant = "";
        message.workspace = "";
        message.modelId = "";
        message.finishReason = 0;
        message.latencyMs = 0n;
        message.isError = false;
        message.errorMessage = "";
        message.parentEventId = "";
        if (value !== undefined)
            reflectionMergePartial<LLMCallEnd>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LLMCallEnd): LLMCallEnd {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string model_id */ 5:
                    message.modelId = reader.string();
                    break;
                case /* agency.infer.v1.FinishReason finish_reason */ 6:
                    message.finishReason = reader.int32();
                    break;
                case /* agency.infer.v1.Usage usage */ 7:
                    message.usage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.usage);
                    break;
                case /* int64 latency_ms */ 8:
                    message.latencyMs = reader.int64().toBigInt();
                    break;
                case /* bool is_error */ 9:
                    message.isError = reader.bool();
                    break;
                case /* string error_message */ 10:
                    message.errorMessage = reader.string();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 11:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* string parent_event_id */ 12:
                    message.parentEventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LLMCallEnd, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string model_id = 5; */
        if (message.modelId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.modelId);
        /* agency.infer.v1.FinishReason finish_reason = 6; */
        if (message.finishReason !== 0)
            writer.tag(6, WireType.Varint).int32(message.finishReason);
        /* agency.infer.v1.Usage usage = 7; */
        if (message.usage)
            Usage.internalBinaryWrite(message.usage, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int64 latency_ms = 8; */
        if (message.latencyMs !== 0n)
            writer.tag(8, WireType.Varint).int64(message.latencyMs);
        /* bool is_error = 9; */
        if (message.isError !== false)
            writer.tag(9, WireType.Varint).bool(message.isError);
        /* string error_message = 10; */
        if (message.errorMessage !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.errorMessage);
        /* google.protobuf.Timestamp completed_at = 11; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string parent_event_id = 12; */
        if (message.parentEventId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.parentEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.LLMCallEnd
 */
export const LLMCallEnd = new LLMCallEnd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionStartedEvent$Type extends MessageType<SessionStartedEvent> {
    constructor() {
        super("agency.events.v1.SessionStartedEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SessionStartedEvent>): SessionStartedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.userSub = "";
        if (value !== undefined)
            reflectionMergePartial<SessionStartedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionStartedEvent): SessionStartedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string user_sub */ 4:
                    message.userSub = reader.string();
                    break;
                case /* google.protobuf.Timestamp started_at */ 5:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionStartedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string user_sub = 4; */
        if (message.userSub !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userSub);
        /* google.protobuf.Timestamp started_at = 5; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SessionStartedEvent
 */
export const SessionStartedEvent = new SessionStartedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionEndedEvent$Type extends MessageType<SessionEndedEvent> {
    constructor() {
        super("agency.events.v1.SessionEndedEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "ended_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SessionEndedEvent>): SessionEndedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.userSub = "";
        if (value !== undefined)
            reflectionMergePartial<SessionEndedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionEndedEvent): SessionEndedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string user_sub */ 4:
                    message.userSub = reader.string();
                    break;
                case /* google.protobuf.Timestamp ended_at */ 5:
                    message.endedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionEndedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string user_sub = 4; */
        if (message.userSub !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userSub);
        /* google.protobuf.Timestamp ended_at = 5; */
        if (message.endedAt)
            Timestamp.internalBinaryWrite(message.endedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SessionEndedEvent
 */
export const SessionEndedEvent = new SessionEndedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionForkedEvent$Type extends MessageType<SessionForkedEvent> {
    constructor() {
        super("agency.events.v1.SessionForkedEvent", [
            { no: 1, name: "child_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "parent_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "fork_turn", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 7, name: "fork_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { uint64: { gte: "1" } } } },
            { no: 8, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 9, name: "forked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SessionForkedEvent>): SessionForkedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.childSessionId = "";
        message.parentSessionId = "";
        message.threadId = "";
        message.tenant = "";
        message.workspace = "";
        message.forkTurn = 0;
        message.forkSeq = 0n;
        message.userSub = "";
        if (value !== undefined)
            reflectionMergePartial<SessionForkedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionForkedEvent): SessionForkedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string child_session_id */ 1:
                    message.childSessionId = reader.string();
                    break;
                case /* string parent_session_id */ 2:
                    message.parentSessionId = reader.string();
                    break;
                case /* string thread_id */ 3:
                    message.threadId = reader.string();
                    break;
                case /* string tenant */ 4:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 5:
                    message.workspace = reader.string();
                    break;
                case /* int32 fork_turn */ 6:
                    message.forkTurn = reader.int32();
                    break;
                case /* uint64 fork_seq */ 7:
                    message.forkSeq = reader.uint64().toBigInt();
                    break;
                case /* string user_sub */ 8:
                    message.userSub = reader.string();
                    break;
                case /* google.protobuf.Timestamp forked_at */ 9:
                    message.forkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.forkedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionForkedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string child_session_id = 1; */
        if (message.childSessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.childSessionId);
        /* string parent_session_id = 2; */
        if (message.parentSessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.parentSessionId);
        /* string thread_id = 3; */
        if (message.threadId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.threadId);
        /* string tenant = 4; */
        if (message.tenant !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 5; */
        if (message.workspace !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.workspace);
        /* int32 fork_turn = 6; */
        if (message.forkTurn !== 0)
            writer.tag(6, WireType.Varint).int32(message.forkTurn);
        /* uint64 fork_seq = 7; */
        if (message.forkSeq !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.forkSeq);
        /* string user_sub = 8; */
        if (message.userSub !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.userSub);
        /* google.protobuf.Timestamp forked_at = 9; */
        if (message.forkedAt)
            Timestamp.internalBinaryWrite(message.forkedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.SessionForkedEvent
 */
export const SessionForkedEvent = new SessionForkedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IngressEvent$Type extends MessageType<IngressEvent> {
    constructor() {
        super("agency.events.v1.IngressEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "payload", kind: "message", T: () => Any, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<IngressEvent>): IngressEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.userSub = "";
        if (value !== undefined)
            reflectionMergePartial<IngressEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IngressEvent): IngressEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string user_sub */ 4:
                    message.userSub = reader.string();
                    break;
                case /* google.protobuf.Any payload */ 5:
                    message.payload = Any.internalBinaryRead(reader, reader.uint32(), options, message.payload);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IngressEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string user_sub = 4; */
        if (message.userSub !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userSub);
        /* google.protobuf.Any payload = 5; */
        if (message.payload)
            Any.internalBinaryWrite(message.payload, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.events.v1.IngressEvent
 */
export const IngressEvent = new IngressEvent$Type();
